// PLANTS TREES
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const treesData: PlantData[] = [
  {
    id: 'apple-dwarf-honeycrisp',
    name: 'Apple - Dwarf Honeycrisp',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic'],
    enemies: ['potato'],
    description: 'Compact 8-10 ft tree. Sweet-tart apples, excellent fresh eating. Needs pollinator.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Rosaceae',
    varieties: ['Honeycrisp', 'Gala', 'Fuji'],
    uses: ['fresh', 'baking', 'cider']
  },
  {
    id: 'peach-dwarf',
    name: 'Peach - Dwarf',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Compact peach tree, 8-10 ft. Self-pollinating. Beautiful spring blooms.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Rosaceae',
    varieties: ['Bonanza', 'Elberta'],
    uses: ['fresh', 'canning', 'pie']
  },
  {
    id: 'pear-dwarf-bartlett',
    name: 'Pear - Dwarf Bartlett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic'],
    enemies: [],
    description: 'Classic green pear turning yellow when ripe. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '8-10 feet',
    family: 'Rosaceae',
    varieties: ['Bartlett', 'Bosc', 'Anjou'],
    uses: ['fresh', 'canning', 'drying']
  },
  {
    id: 'plum-dwarf',
    name: 'Plum - Dwarf',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: ['tomato'],
    description: 'Compact plum tree with sweet purple fruit. Self-pollinating.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Rosaceae',
    varieties: ['Stanley', 'Mount Royal'],
    uses: ['fresh', 'prunes', 'jam']
  },
  {
    id: 'cherry-sour-montmorency',
    name: 'Cherry - Sour Montmorency',
    scientificName: 'Prunus cerasus',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: ['tomato'],
    description: 'Tart red pie cherry. Self-pollinating, smaller tree than sweet cherries.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Montmorency', 'Morello'],
    uses: ['pie', 'preserves', 'dried']
  },
  {
    id: 'fig-chicago-hardy',
    name: 'Fig - Chicago Hardy',
    scientificName: 'Ficus carica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'low',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Cold hardy fig to zone 5 with winter protection. Brown skin, pink flesh.',
    hardinessZones: '5-10',
    plantingSeason: 'spring',
    height: '10-15 feet',
    spread: '10-12 feet',
    family: 'Moraceae',
    varieties: ['Chicago Hardy', 'Brown Turkey'],
    uses: ['fresh', 'dried', 'jam']
  },
  {
    id: 'lemon-meyer-dwarf',
    name: 'Lemon - Meyer Dwarf',
    scientificName: 'Citrus x meyeri',
    category: 'tree',
    spacing: 72,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Compact lemon tree for containers. Sweeter than standard lemons. Bring indoors in winter.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rutaceae',
    varieties: ['Meyer'],
    uses: ['cooking', 'juice', 'cocktails']
  },
  {
    id: 'pawpaw-tree',
    name: 'Pawpaw Tree',
    scientificName: 'Asimina triloba',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Native North American fruit with custard-like texture. Needs two varieties.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '15-25 feet',
    spread: '15-20 feet',
    family: 'Annonaceae',
    varieties: ['Pennsylvania Golden', 'Sunflower'],
    uses: ['fresh', 'custard', 'ice cream']
  }
,
  {
    id: 'apple-honeycrisp',
    name: 'Apple - Honeycrisp',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Honeycrisp apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Honeycrisp'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-gala',
    name: 'Apple - Gala',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Gala apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gala'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-fuji',
    name: 'Apple - Fuji',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Fuji apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fuji'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-granny-smith',
    name: 'Apple - Granny Smith',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Granny Smith apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Granny Smith'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-red-delicious',
    name: 'Apple - Red Delicious',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Delicious apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Delicious'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-golden-delicious',
    name: 'Apple - Golden Delicious',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Golden Delicious apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Golden Delicious'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-mcintosh',
    name: 'Apple - McIntosh',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'McIntosh apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['McIntosh'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-jonathan',
    name: 'Apple - Jonathan',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonathan apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonathan'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-rome',
    name: 'Apple - Rome',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rome apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rome'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-braeburn',
    name: 'Apple - Braeburn',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Braeburn apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Braeburn'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pink-lady',
    name: 'Apple - Pink Lady',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pink Lady apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pink Lady'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-jazz',
    name: 'Apple - Jazz',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jazz apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jazz'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-envy',
    name: 'Apple - Envy',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Envy apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Envy'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-opal',
    name: 'Apple - Opal',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Opal apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Opal'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-cosmic-crisp',
    name: 'Apple - Cosmic Crisp',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cosmic Crisp apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cosmic Crisp'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-sweetango',
    name: 'Apple - SweeTango',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'SweeTango apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['SweeTango'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-evercrisp',
    name: 'Apple - EverCrisp',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'EverCrisp apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['EverCrisp'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-kanzi',
    name: 'Apple - Kanzi',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Kanzi apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kanzi'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pacific-rose',
    name: 'Apple - Pacific Rose',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pacific Rose apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pacific Rose'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-lady-alice',
    name: 'Apple - Lady Alice',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lady Alice apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lady Alice'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-zestar',
    name: 'Apple - Zestar',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Zestar apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Zestar'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-snowsweet',
    name: 'Apple - SnowSweet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'SnowSweet apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['SnowSweet'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-frostbite',
    name: 'Apple - Frostbite',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Frostbite apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frostbite'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-haralson',
    name: 'Apple - Haralson',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Haralson apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Haralson'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-wealthy',
    name: 'Apple - Wealthy',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wealthy apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wealthy'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-cortland',
    name: 'Apple - Cortland',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cortland apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cortland'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-empire',
    name: 'Apple - Empire',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Empire apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Empire'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-macoun',
    name: 'Apple - Macoun',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Macoun apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Macoun'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-northern-spy',
    name: 'Apple - Northern Spy',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northern Spy apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northern Spy'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-rhode-island-greening',
    name: 'Apple - Rhode Island Greening',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rhode Island Greening apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rhode Island Greening'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-winesap',
    name: 'Apple - Winesap',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Winesap apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Winesap'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-stayman',
    name: 'Apple - Stayman',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Stayman apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stayman'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-york-imperial',
    name: 'Apple - York Imperial',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'York Imperial apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['York Imperial'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ben-davis',
    name: 'Apple - Ben Davis',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ben Davis apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ben Davis'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-arkansas-black',
    name: 'Apple - Arkansas Black',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Arkansas Black apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arkansas Black'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-ashmead-kernel',
    name: 'Apple - Ashmead Kernel',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ashmead Kernel apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ashmead Kernel'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-baldwin',
    name: 'Apple - Baldwin',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Baldwin apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Baldwin'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-bellflower',
    name: 'Apple - Bellflower',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Bellflower apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bellflower'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-black-oxford',
    name: 'Apple - Black Oxford',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Black Oxford apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Black Oxford'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-blue-pearmain',
    name: 'Apple - Blue Pearmain',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Blue Pearmain apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blue Pearmain'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-bramley-seedling',
    name: 'Apple - Bramley Seedling',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Bramley Seedling apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bramley Seedling'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-calville-blanc',
    name: 'Apple - Calville Blanc',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Calville Blanc apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Calville Blanc'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-cox-orange-pippin',
    name: 'Apple - Cox Orange Pippin',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cox Orange Pippin apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cox Orange Pippin'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-criterion',
    name: 'Apple - Criterion',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Criterion apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Criterion'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-delicious',
    name: 'Apple - Delicious',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Delicious apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delicious'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-dorsett-golden',
    name: 'Apple - Dorsett Golden',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Dorsett Golden apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dorsett Golden'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-egremont-russet',
    name: 'Apple - Egremont Russet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Egremont Russet apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Egremont Russet'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-elstar',
    name: 'Apple - Elstar',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Elstar apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elstar'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-enterprise',
    name: 'Apple - Enterprise',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Enterprise apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Enterprise'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-esopus-spitzenburg',
    name: 'Apple - Esopus Spitzenburg',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Esopus Spitzenburg apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Esopus Spitzenburg'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-fireside',
    name: 'Apple - Fireside',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Fireside apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fireside'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-freedom',
    name: 'Apple - Freedom',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Freedom apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Freedom'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-freyberg',
    name: 'Apple - Freyberg',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Freyberg apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Freyberg'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-ginger-gold',
    name: 'Apple - Ginger Gold',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ginger Gold apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ginger Gold'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-goldrush',
    name: 'Apple - GoldRush',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'GoldRush apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['GoldRush'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-gravenstein',
    name: 'Apple - Gravenstein',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Gravenstein apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gravenstein'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-harrison',
    name: 'Apple - Harrison',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Harrison apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrison'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-hawaii',
    name: 'Apple - Hawaii',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hawaii apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hawaii'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-hidden-rose',
    name: 'Apple - Hidden Rose',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hidden Rose apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hidden Rose'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-hokuto',
    name: 'Apple - Hokuto',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hokuto apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hokuto'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-hudson-golden-gem',
    name: 'Apple - Hudson Golden Gem',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hudson Golden Gem apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hudson Golden Gem'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-idared',
    name: 'Apple - Idared',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Idared apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Idared'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-initial',
    name: 'Apple - Initial',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Initial apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Initial'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-irish-peach',
    name: 'Apple - Irish Peach',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Irish Peach apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Irish Peach'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-james-grieve',
    name: 'Apple - James Grieve',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'James Grieve apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['James Grieve'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-jersey-mac',
    name: 'Apple - Jersey Mac',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jersey Mac apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jersey Mac'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-jonagold',
    name: 'Apple - Jonagold',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonagold apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonagold'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-jonamac',
    name: 'Apple - Jonamac',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonamac apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonamac'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-jonalicious',
    name: 'Apple - Jonalicious',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonalicious apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonalicious'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-juliet',
    name: 'Apple - Juliet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Juliet apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Juliet'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-karmijn-de-sonnaville',
    name: 'Apple - Karmijn de Sonnaville',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Karmijn de Sonnaville apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Karmijn de Sonnaville'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-king-david',
    name: 'Apple - King David',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'King David apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['King David'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-king-luscious',
    name: 'Apple - King Luscious',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'King Luscious apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['King Luscious'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-kidd-orange-red',
    name: 'Apple - Kidd Orange Red',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Kidd Orange Red apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kidd Orange Red'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-lady',
    name: 'Apple - Lady',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lady apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lady'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-landsberger-reinette',
    name: 'Apple - Landsberger Reinette',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Landsberger Reinette apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Landsberger Reinette'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-liberty',
    name: 'Apple - Liberty',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Liberty apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Liberty'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-lodi',
    name: 'Apple - Lodi',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lodi apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lodi'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-lord-derby',
    name: 'Apple - Lord Derby',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lord Derby apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lord Derby'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-macoun',
    name: 'Apple - Macoun',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Macoun apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Macoun'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-magnum-bonum',
    name: 'Apple - Magnum Bonum',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Magnum Bonum apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Magnum Bonum'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-maiden-blush',
    name: 'Apple - Maiden Blush',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Maiden Blush apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Maiden Blush'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-margil',
    name: 'Apple - Margil',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Margil apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Margil'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-melrose',
    name: 'Apple - Melrose',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Melrose apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Melrose'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-mollies-delicious',
    name: 'Apple - Mollies Delicious',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mollies Delicious apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mollies Delicious'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-mother',
    name: 'Apple - Mother',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mother apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mother'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-mutsu',
    name: 'Apple - Mutsu',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mutsu apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mutsu'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-newtown-pippin',
    name: 'Apple - Newtown Pippin',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Newtown Pippin apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Newtown Pippin'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-newton',
    name: 'Apple - Newton',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Newton apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Newton'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-nickajack',
    name: 'Apple - Nickajack',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Nickajack apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nickajack'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-northfield-beauty',
    name: 'Apple - Northfield Beauty',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northfield Beauty apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northfield Beauty'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-northwest-greening',
    name: 'Apple - Northwest Greening',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northwest Greening apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northwest Greening'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-nova-easygro',
    name: 'Apple - Nova Easygro',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Nova Easygro apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nova Easygro'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-novamac',
    name: 'Apple - Novamac',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Novamac apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Novamac'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-oriole',
    name: 'Apple - Oriole',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Oriole apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Oriole'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-orleans-reinette',
    name: 'Apple - Orleans Reinette',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Orleans Reinette apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Orleans Reinette'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ozark-gold',
    name: 'Apple - Ozark Gold',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ozark Gold apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ozark Gold'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-paulared',
    name: 'Apple - Paulared',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Paulared apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Paulared'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pepin-spicy',
    name: 'Apple - Pepin Spicy',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pepin Spicy apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pepin Spicy'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pineapple',
    name: 'Apple - Pineapple',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pineapple apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pineapple'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pioneer-mac',
    name: 'Apple - Pioneer Mac',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pioneer Mac apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pioneer Mac'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pitmaston-pineapple',
    name: 'Apple - Pitmaston Pineapple',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pitmaston Pineapple apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pitmaston Pineapple'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pomme-gris',
    name: 'Apple - Pomme Gris',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pomme Gris apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pomme Gris'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-porter',
    name: 'Apple - Porter',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Porter apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Porter'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pound-sweet',
    name: 'Apple - Pound Sweet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pound Sweet apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pound Sweet'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-prima',
    name: 'Apple - Prima',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Prima apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Prima'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-priscilla',
    name: 'Apple - Priscilla',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Priscilla apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Priscilla'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pristine',
    name: 'Apple - Pristine',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pristine apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pristine'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-queen',
    name: 'Apple - Queen',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Queen apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Queen'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-querina',
    name: 'Apple - Querina',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Querina apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Querina'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-ralls-genet',
    name: 'Apple - Ralls Genet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ralls Genet apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ralls Genet'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-raritan',
    name: 'Apple - Raritan',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Raritan apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Raritan'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-red-astrachan',
    name: 'Apple - Red Astrachan',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Astrachan apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Astrachan'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-red-baron',
    name: 'Apple - Red Baron',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Baron apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Baron'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-red-free',
    name: 'Apple - Red Free',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Free apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Free'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-red-gravenstein',
    name: 'Apple - Red Gravenstein',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Gravenstein apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Gravenstein'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-red-rome',
    name: 'Apple - Red Rome',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Rome apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Rome'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-redfield',
    name: 'Apple - Redfield',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Redfield apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redfield'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-reine-des-reinettes',
    name: 'Apple - Reine des Reinettes',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Reine des Reinettes apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Reine des Reinettes'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-ribston-pippin',
    name: 'Apple - Ribston Pippin',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ribston Pippin apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ribston Pippin'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-roxbury-russet',
    name: 'Apple - Roxbury Russet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Roxbury Russet apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Roxbury Russet'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-rubinette',
    name: 'Apple - Rubinette',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rubinette apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rubinette'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-rusty-coat',
    name: 'Apple - Rusty Coat',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rusty Coat apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rusty Coat'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-sansa',
    name: 'Apple - Sansa',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sansa apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sansa'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sauce',
    name: 'Apple - Sauce',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sauce apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sauce'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-scarlet-surprise',
    name: 'Apple - Scarlet Surprise',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Scarlet Surprise apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Scarlet Surprise'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-scott-winter',
    name: 'Apple - Scott Winter',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Scott Winter apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Scott Winter'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sekai-ichi',
    name: 'Apple - Sekai Ichi',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sekai Ichi apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sekai Ichi'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-senshu',
    name: 'Apple - Senshu',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Senshu apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Senshu'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-sierra-beauty',
    name: 'Apple - Sierra Beauty',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sierra Beauty apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sierra Beauty'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sir-prize',
    name: 'Apple - Sir Prize',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sir Prize apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sir Prize'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-sops-of-wine',
    name: 'Apple - Sops of Wine',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sops of Wine apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sops of Wine'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-spartan',
    name: 'Apple - Spartan',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Spartan apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spartan'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-spigold',
    name: 'Apple - Spigold',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Spigold apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spigold'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-spijon',
    name: 'Apple - Spijon',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Spijon apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spijon'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-splendour',
    name: 'Apple - Splendour',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Splendour apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Splendour'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-starr',
    name: 'Apple - Starr',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Starr apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Starr'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-state-fair',
    name: 'Apple - State Fair',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'State Fair apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['State Fair'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-summer-mac',
    name: 'Apple - Summer Mac',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Summer Mac apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Mac'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-summer-rambo',
    name: 'Apple - Summer Rambo',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Summer Rambo apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Rambo'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-summer-rose',
    name: 'Apple - Summer Rose',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Summer Rose apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Rose'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-sundance',
    name: 'Apple - Sundance',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sundance apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sundance'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sunrise',
    name: 'Apple - Sunrise',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sunrise apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunrise'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-suntan',
    name: 'Apple - Suntan',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Suntan apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Suntan'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-tentation',
    name: 'Apple - Tentation',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tentation apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tentation'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-tollman-sweet',
    name: 'Apple - Tollman Sweet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tollman Sweet apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tollman Sweet'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-topaz',
    name: 'Apple - Topaz',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Topaz apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Topaz'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-tremlett-bitter',
    name: 'Apple - Tremlett Bitter',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tremlett Bitter apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tremlett Bitter'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-twenty-ounce',
    name: 'Apple - Twenty Ounce',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Twenty Ounce apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Twenty Ounce'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-tyeman',
    name: 'Apple - Tyeman',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tyeman apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tyeman'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-vandevere',
    name: 'Apple - Vandevere',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Vandevere apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Vandevere'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-viking',
    name: 'Apple - Viking',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Viking apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Viking'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-virginia-gold',
    name: 'Apple - Virginia Gold',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Virginia Gold apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Virginia Gold'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-vista-bella',
    name: 'Apple - Vista Bella',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Vista Bella apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Vista Bella'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-waltana',
    name: 'Apple - Waltana',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Waltana apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Waltana'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-warner-king',
    name: 'Apple - Warner King',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Warner King apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Warner King'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-wealthy',
    name: 'Apple - Wealthy',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wealthy apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wealthy'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-westfield-seek-no-further',
    name: 'Apple - Westfield Seek-No-Further',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Westfield Seek-No-Further apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Westfield Seek-No-Further'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-white-pearmain',
    name: 'Apple - White Pearmain',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'White Pearmain apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['White Pearmain'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-william-pride',
    name: 'Apple - William Pride',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'William Pride apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['William Pride'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-william-crump',
    name: 'Apple - William Crump',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'William Crump apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['William Crump'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-winesap',
    name: 'Apple - Winesap',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Winesap apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Winesap'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-winter-banana',
    name: 'Apple - Winter Banana',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Winter Banana apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Winter Banana'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-wolf-river',
    name: 'Apple - Wolf River',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wolf River apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wolf River'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-woods-pink',
    name: 'Apple - Woods Pink',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Woods Pink apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Woods Pink'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-wyken-pippin',
    name: 'Apple - Wyken Pippin',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wyken Pippin apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wyken Pippin'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-yates',
    name: 'Apple - Yates',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Yates apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yates'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-yellow-bellflower',
    name: 'Apple - Yellow Bellflower',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Yellow Bellflower apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Bellflower'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-yellow-transparent',
    name: 'Apple - Yellow Transparent',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Yellow Transparent apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Transparent'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-york',
    name: 'Apple - York',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'York apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['York'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-zabergau-reinette',
    name: 'Apple - Zabergau Reinette',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Zabergau Reinette apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Zabergau Reinette'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-zestar',
    name: 'Apple - Zestar',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Zestar apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Zestar'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-adanac',
    name: 'Apple - Adanac',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Adanac apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Adanac'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-akane',
    name: 'Apple - Akane',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Akane apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Akane'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-alderman',
    name: 'Apple - Alderman',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Alderman apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Alderman'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-alexander',
    name: 'Apple - Alexander',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Alexander apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Alexander'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-alfred-hitchcock',
    name: 'Apple - Alfred Hitchcock',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Alfred Hitchcock apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Alfred Hitchcock'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-allen-everlasting',
    name: 'Apple - Allen Everlasting',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Allen Everlasting apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Allen Everlasting'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-almata',
    name: 'Apple - Almata',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Almata apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Almata'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-amsden',
    name: 'Apple - Amsden',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Amsden apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Amsden'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ananas-reinette',
    name: 'Apple - Ananas Reinette',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ananas Reinette apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ananas Reinette'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-annie-elizabeth',
    name: 'Apple - Annie Elizabeth',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Annie Elizabeth apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Annie Elizabeth'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-antonovka',
    name: 'Apple - Antonovka',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Antonovka apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Antonovka'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-api',
    name: 'Apple - Api',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Api apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Api'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-apollo',
    name: 'Apple - Apollo',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Apollo apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Apollo'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-ard-cairn-russet',
    name: 'Apple - Ard Cairn Russet',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ard Cairn Russet apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ard Cairn Russet'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ariane',
    name: 'Apple - Ariane',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ariane apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ariane'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-aroma',
    name: 'Apple - Aroma',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Aroma apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Aroma'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-arthur-turner',
    name: 'Apple - Arthur Turner',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Arthur Turner apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arthur Turner'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ashmeads-kernel',
    name: 'Apple - Ashmeads Kernel',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ashmeads Kernel apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ashmeads Kernel'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-aurora',
    name: 'Apple - Aurora',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Aurora apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Aurora'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-autumn-bough',
    name: 'Apple - Autumn Bough',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Bough apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Bough'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-autumn-crisp',
    name: 'Apple - Autumn Crisp',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Crisp apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Crisp'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-autumn-glory',
    name: 'Apple - Autumn Glory',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Glory apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Glory'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-autumn-rose',
    name: 'Apple - Autumn Rose',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Rose apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Rose'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-baker',
    name: 'Apple - Baker',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Baker apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Baker'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-honeycrisp-2',
    name: 'Apple - Honeycrisp 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Honeycrisp 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Honeycrisp 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-gala-2',
    name: 'Apple - Gala 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Gala 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gala 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-fuji-2',
    name: 'Apple - Fuji 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Fuji 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fuji 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-granny-smith-2',
    name: 'Apple - Granny Smith 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Granny Smith 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Granny Smith 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-red-delicious-2',
    name: 'Apple - Red Delicious 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Delicious 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Delicious 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-golden-delicious-2',
    name: 'Apple - Golden Delicious 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Golden Delicious 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Golden Delicious 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-mcintosh-2',
    name: 'Apple - McIntosh 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'McIntosh 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['McIntosh 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-jonathan-2',
    name: 'Apple - Jonathan 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonathan 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonathan 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-rome-2',
    name: 'Apple - Rome 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rome 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rome 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-braeburn-2',
    name: 'Apple - Braeburn 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Braeburn 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Braeburn 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pink-lady-2',
    name: 'Apple - Pink Lady 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pink Lady 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pink Lady 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-jazz-2',
    name: 'Apple - Jazz 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jazz 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jazz 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-envy-2',
    name: 'Apple - Envy 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Envy 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Envy 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-opal-2',
    name: 'Apple - Opal 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Opal 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Opal 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-cosmic-crisp-2',
    name: 'Apple - Cosmic Crisp 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cosmic Crisp 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cosmic Crisp 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sweetango-2',
    name: 'Apple - SweeTango 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'SweeTango 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['SweeTango 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-evercrisp-2',
    name: 'Apple - EverCrisp 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'EverCrisp 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['EverCrisp 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-kanzi-2',
    name: 'Apple - Kanzi 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Kanzi 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kanzi 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pacific-rose-2',
    name: 'Apple - Pacific Rose 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pacific Rose 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pacific Rose 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-lady-alice-2',
    name: 'Apple - Lady Alice 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lady Alice 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lady Alice 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-zestar-2',
    name: 'Apple - Zestar 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Zestar 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Zestar 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-snowsweet-2',
    name: 'Apple - SnowSweet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'SnowSweet 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['SnowSweet 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-frostbite-2',
    name: 'Apple - Frostbite 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Frostbite 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frostbite 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-haralson-2',
    name: 'Apple - Haralson 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Haralson 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Haralson 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-wealthy-2',
    name: 'Apple - Wealthy 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wealthy 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wealthy 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-cortland-2',
    name: 'Apple - Cortland 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cortland 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cortland 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-empire-2',
    name: 'Apple - Empire 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Empire 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Empire 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-macoun-2',
    name: 'Apple - Macoun 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Macoun 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Macoun 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-northern-spy-2',
    name: 'Apple - Northern Spy 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northern Spy 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northern Spy 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-rhode-island-greening-2',
    name: 'Apple - Rhode Island Greening 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rhode Island Greening 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rhode Island Greening 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-winesap-2',
    name: 'Apple - Winesap 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Winesap 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Winesap 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-stayman-2',
    name: 'Apple - Stayman 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Stayman 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stayman 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-york-imperial-2',
    name: 'Apple - York Imperial 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'York Imperial 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['York Imperial 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-ben-davis-2',
    name: 'Apple - Ben Davis 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ben Davis 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ben Davis 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-arkansas-black-2',
    name: 'Apple - Arkansas Black 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Arkansas Black 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arkansas Black 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ashmead-kernel-2',
    name: 'Apple - Ashmead Kernel 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ashmead Kernel 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ashmead Kernel 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-baldwin-2',
    name: 'Apple - Baldwin 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Baldwin 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Baldwin 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-bellflower-2',
    name: 'Apple - Bellflower 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Bellflower 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bellflower 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-black-oxford-2',
    name: 'Apple - Black Oxford 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Black Oxford 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Black Oxford 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-blue-pearmain-2',
    name: 'Apple - Blue Pearmain 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Blue Pearmain 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blue Pearmain 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-bramley-seedling-2',
    name: 'Apple - Bramley Seedling 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Bramley Seedling 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bramley Seedling 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-calville-blanc-2',
    name: 'Apple - Calville Blanc 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Calville Blanc 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Calville Blanc 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-cox-orange-pippin-2',
    name: 'Apple - Cox Orange Pippin 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cox Orange Pippin 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cox Orange Pippin 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-criterion-2',
    name: 'Apple - Criterion 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Criterion 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Criterion 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-delicious-2',
    name: 'Apple - Delicious 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Delicious 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delicious 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-dorsett-golden-2',
    name: 'Apple - Dorsett Golden 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Dorsett Golden 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dorsett Golden 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-egremont-russet-2',
    name: 'Apple - Egremont Russet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Egremont Russet 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Egremont Russet 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-elstar-2',
    name: 'Apple - Elstar 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Elstar 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elstar 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-enterprise-2',
    name: 'Apple - Enterprise 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Enterprise 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Enterprise 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-esopus-spitzenburg-2',
    name: 'Apple - Esopus Spitzenburg 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Esopus Spitzenburg 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Esopus Spitzenburg 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-fireside-2',
    name: 'Apple - Fireside 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Fireside 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fireside 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-freedom-2',
    name: 'Apple - Freedom 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Freedom 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Freedom 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-freyberg-2',
    name: 'Apple - Freyberg 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Freyberg 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Freyberg 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ginger-gold-2',
    name: 'Apple - Ginger Gold 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ginger Gold 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ginger Gold 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-goldrush-2',
    name: 'Apple - GoldRush 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'GoldRush 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['GoldRush 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-gravenstein-2',
    name: 'Apple - Gravenstein 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Gravenstein 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gravenstein 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-harrison-2',
    name: 'Apple - Harrison 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Harrison 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrison 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-hawaii-2',
    name: 'Apple - Hawaii 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hawaii 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hawaii 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-hidden-rose-2',
    name: 'Apple - Hidden Rose 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hidden Rose 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hidden Rose 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-hokuto-2',
    name: 'Apple - Hokuto 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hokuto 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hokuto 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-hudson-golden-gem-2',
    name: 'Apple - Hudson Golden Gem 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hudson Golden Gem 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hudson Golden Gem 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-idared-2',
    name: 'Apple - Idared 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Idared 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Idared 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-initial-2',
    name: 'Apple - Initial 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Initial 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Initial 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-irish-peach-2',
    name: 'Apple - Irish Peach 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Irish Peach 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Irish Peach 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-james-grieve-2',
    name: 'Apple - James Grieve 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'James Grieve 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['James Grieve 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-jersey-mac-2',
    name: 'Apple - Jersey Mac 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jersey Mac 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jersey Mac 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-jonagold-2',
    name: 'Apple - Jonagold 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonagold 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonagold 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-jonamac-2',
    name: 'Apple - Jonamac 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonamac 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonamac 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-jonalicious-2',
    name: 'Apple - Jonalicious 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonalicious 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonalicious 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-juliet-2',
    name: 'Apple - Juliet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Juliet 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Juliet 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-karmijn-de-sonnaville-2',
    name: 'Apple - Karmijn de Sonnaville 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Karmijn de Sonnaville 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Karmijn de Sonnaville 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-king-david-2',
    name: 'Apple - King David 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'King David 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['King David 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-king-luscious-2',
    name: 'Apple - King Luscious 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'King Luscious 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['King Luscious 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-kidd-orange-red-2',
    name: 'Apple - Kidd Orange Red 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Kidd Orange Red 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kidd Orange Red 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-lady-2',
    name: 'Apple - Lady 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lady 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lady 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-landsberger-reinette-2',
    name: 'Apple - Landsberger Reinette 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Landsberger Reinette 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Landsberger Reinette 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-liberty-2',
    name: 'Apple - Liberty 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Liberty 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Liberty 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-lodi-2',
    name: 'Apple - Lodi 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lodi 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lodi 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-lord-derby-2',
    name: 'Apple - Lord Derby 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lord Derby 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lord Derby 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-macoun-2',
    name: 'Apple - Macoun 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Macoun 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Macoun 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-magnum-bonum-2',
    name: 'Apple - Magnum Bonum 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Magnum Bonum 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Magnum Bonum 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-maiden-blush-2',
    name: 'Apple - Maiden Blush 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Maiden Blush 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Maiden Blush 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-margil-2',
    name: 'Apple - Margil 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Margil 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Margil 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-melrose-2',
    name: 'Apple - Melrose 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Melrose 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Melrose 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-mollies-delicious-2',
    name: 'Apple - Mollies Delicious 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mollies Delicious 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mollies Delicious 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-mother-2',
    name: 'Apple - Mother 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mother 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mother 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-mutsu-2',
    name: 'Apple - Mutsu 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mutsu 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mutsu 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-newtown-pippin-2',
    name: 'Apple - Newtown Pippin 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Newtown Pippin 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Newtown Pippin 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-newton-2',
    name: 'Apple - Newton 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Newton 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Newton 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-nickajack-2',
    name: 'Apple - Nickajack 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Nickajack 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nickajack 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-northfield-beauty-2',
    name: 'Apple - Northfield Beauty 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northfield Beauty 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northfield Beauty 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-northwest-greening-2',
    name: 'Apple - Northwest Greening 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northwest Greening 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northwest Greening 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-nova-easygro-2',
    name: 'Apple - Nova Easygro 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Nova Easygro 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nova Easygro 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-novamac-2',
    name: 'Apple - Novamac 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Novamac 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Novamac 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-oriole-2',
    name: 'Apple - Oriole 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Oriole 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Oriole 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-orleans-reinette-2',
    name: 'Apple - Orleans Reinette 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Orleans Reinette 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Orleans Reinette 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-ozark-gold-2',
    name: 'Apple - Ozark Gold 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ozark Gold 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ozark Gold 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-paulared-2',
    name: 'Apple - Paulared 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Paulared 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Paulared 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pepin-spicy-2',
    name: 'Apple - Pepin Spicy 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pepin Spicy 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pepin Spicy 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pineapple-2',
    name: 'Apple - Pineapple 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pineapple 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pineapple 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pioneer-mac-2',
    name: 'Apple - Pioneer Mac 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pioneer Mac 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pioneer Mac 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pitmaston-pineapple-2',
    name: 'Apple - Pitmaston Pineapple 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pitmaston Pineapple 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pitmaston Pineapple 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pomme-gris-2',
    name: 'Apple - Pomme Gris 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pomme Gris 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pomme Gris 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-porter-2',
    name: 'Apple - Porter 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Porter 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Porter 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pound-sweet-2',
    name: 'Apple - Pound Sweet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pound Sweet 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pound Sweet 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-prima-2',
    name: 'Apple - Prima 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Prima 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Prima 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-priscilla-2',
    name: 'Apple - Priscilla 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Priscilla 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Priscilla 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pristine-2',
    name: 'Apple - Pristine 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pristine 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pristine 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-queen-2',
    name: 'Apple - Queen 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Queen 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Queen 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-querina-2',
    name: 'Apple - Querina 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Querina 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Querina 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ralls-genet-2',
    name: 'Apple - Ralls Genet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ralls Genet 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ralls Genet 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-raritan-2',
    name: 'Apple - Raritan 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Raritan 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Raritan 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-red-astrachan-2',
    name: 'Apple - Red Astrachan 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Astrachan 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Astrachan 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-red-baron-2',
    name: 'Apple - Red Baron 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Baron 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Baron 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-red-free-2',
    name: 'Apple - Red Free 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Free 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Free 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-red-gravenstein-2',
    name: 'Apple - Red Gravenstein 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Gravenstein 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Gravenstein 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-red-rome-2',
    name: 'Apple - Red Rome 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Rome 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Rome 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-redfield-2',
    name: 'Apple - Redfield 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Redfield 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redfield 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-reine-des-reinettes-2',
    name: 'Apple - Reine des Reinettes 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Reine des Reinettes 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Reine des Reinettes 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ribston-pippin-2',
    name: 'Apple - Ribston Pippin 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ribston Pippin 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ribston Pippin 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-roxbury-russet-2',
    name: 'Apple - Roxbury Russet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Roxbury Russet 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Roxbury Russet 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-rubinette-2',
    name: 'Apple - Rubinette 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rubinette 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rubinette 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-rusty-coat-2',
    name: 'Apple - Rusty Coat 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rusty Coat 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rusty Coat 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sansa-2',
    name: 'Apple - Sansa 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sansa 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sansa 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-sauce-2',
    name: 'Apple - Sauce 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sauce 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sauce 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-scarlet-surprise-2',
    name: 'Apple - Scarlet Surprise 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Scarlet Surprise 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Scarlet Surprise 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-scott-winter-2',
    name: 'Apple - Scott Winter 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Scott Winter 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Scott Winter 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-sekai-ichi-2',
    name: 'Apple - Sekai Ichi 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sekai Ichi 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sekai Ichi 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-senshu-2',
    name: 'Apple - Senshu 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Senshu 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Senshu 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sierra-beauty-2',
    name: 'Apple - Sierra Beauty 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sierra Beauty 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sierra Beauty 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-sir-prize-2',
    name: 'Apple - Sir Prize 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sir Prize 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sir Prize 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-sops-of-wine-2',
    name: 'Apple - Sops of Wine 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sops of Wine 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sops of Wine 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-spartan-2',
    name: 'Apple - Spartan 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Spartan 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spartan 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-spigold-2',
    name: 'Apple - Spigold 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Spigold 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spigold 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-spijon-2',
    name: 'Apple - Spijon 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Spijon 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spijon 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-splendour-2',
    name: 'Apple - Splendour 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Splendour 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Splendour 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-starr-2',
    name: 'Apple - Starr 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Starr 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Starr 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-state-fair-2',
    name: 'Apple - State Fair 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'State Fair 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['State Fair 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-summer-mac-2',
    name: 'Apple - Summer Mac 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Summer Mac 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Mac 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-summer-rambo-2',
    name: 'Apple - Summer Rambo 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Summer Rambo 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Rambo 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-summer-rose-2',
    name: 'Apple - Summer Rose 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Summer Rose 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Rose 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-sundance-2',
    name: 'Apple - Sundance 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sundance 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sundance 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-sunrise-2',
    name: 'Apple - Sunrise 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Sunrise 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunrise 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-suntan-2',
    name: 'Apple - Suntan 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Suntan 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Suntan 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-tentation-2',
    name: 'Apple - Tentation 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tentation 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tentation 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-tollman-sweet-2',
    name: 'Apple - Tollman Sweet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tollman Sweet 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tollman Sweet 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-topaz-2',
    name: 'Apple - Topaz 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Topaz 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Topaz 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-tremlett-bitter-2',
    name: 'Apple - Tremlett Bitter 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tremlett Bitter 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tremlett Bitter 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-twenty-ounce-2',
    name: 'Apple - Twenty Ounce 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Twenty Ounce 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Twenty Ounce 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-tyeman-2',
    name: 'Apple - Tyeman 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Tyeman 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tyeman 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-vandevere-2',
    name: 'Apple - Vandevere 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Vandevere 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Vandevere 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-viking-2',
    name: 'Apple - Viking 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Viking 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Viking 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-virginia-gold-2',
    name: 'Apple - Virginia Gold 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Virginia Gold 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Virginia Gold 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-vista-bella-2',
    name: 'Apple - Vista Bella 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Vista Bella 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Vista Bella 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-waltana-2',
    name: 'Apple - Waltana 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Waltana 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Waltana 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-warner-king-2',
    name: 'Apple - Warner King 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Warner King 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Warner King 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-wealthy-2',
    name: 'Apple - Wealthy 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wealthy 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wealthy 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-westfield-seek-no-further-2',
    name: 'Apple - Westfield Seek-No-Further 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Westfield Seek-No-Further 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Westfield Seek-No-Further 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-white-pearmain-2',
    name: 'Apple - White Pearmain 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'White Pearmain 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['White Pearmain 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-william-pride-2',
    name: 'Apple - William Pride 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'William Pride 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['William Pride 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-william-crump-2',
    name: 'Apple - William Crump 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'William Crump 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['William Crump 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-winesap-2',
    name: 'Apple - Winesap 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Winesap 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Winesap 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-winter-banana-2',
    name: 'Apple - Winter Banana 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Winter Banana 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Winter Banana 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-wolf-river-2',
    name: 'Apple - Wolf River 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wolf River 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wolf River 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-woods-pink-2',
    name: 'Apple - Woods Pink 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Woods Pink 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Woods Pink 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-wyken-pippin-2',
    name: 'Apple - Wyken Pippin 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wyken Pippin 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wyken Pippin 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-yates-2',
    name: 'Apple - Yates 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Yates 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yates 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-yellow-bellflower-2',
    name: 'Apple - Yellow Bellflower 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Yellow Bellflower 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Bellflower 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-yellow-transparent-2',
    name: 'Apple - Yellow Transparent 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Yellow Transparent 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Transparent 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-york-2',
    name: 'Apple - York 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'York 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['York 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-zabergau-reinette-2',
    name: 'Apple - Zabergau Reinette 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Zabergau Reinette 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Zabergau Reinette 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-zestar-2',
    name: 'Apple - Zestar 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Zestar 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Zestar 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-adanac-2',
    name: 'Apple - Adanac 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Adanac 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Adanac 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-akane-2',
    name: 'Apple - Akane 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Akane 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Akane 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-alderman-2',
    name: 'Apple - Alderman 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Alderman 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Alderman 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-alexander-2',
    name: 'Apple - Alexander 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Alexander 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Alexander 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-alfred-hitchcock-2',
    name: 'Apple - Alfred Hitchcock 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Alfred Hitchcock 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Alfred Hitchcock 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-allen-everlasting-2',
    name: 'Apple - Allen Everlasting 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Allen Everlasting 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Allen Everlasting 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-almata-2',
    name: 'Apple - Almata 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Almata 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Almata 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-amsden-2',
    name: 'Apple - Amsden 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Amsden 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Amsden 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-ananas-reinette-2',
    name: 'Apple - Ananas Reinette 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ananas Reinette 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ananas Reinette 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-annie-elizabeth-2',
    name: 'Apple - Annie Elizabeth 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Annie Elizabeth 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Annie Elizabeth 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-antonovka-2',
    name: 'Apple - Antonovka 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Antonovka 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Antonovka 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-api-2',
    name: 'Apple - Api 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Api 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Api 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-apollo-2',
    name: 'Apple - Apollo 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Apollo 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Apollo 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-ard-cairn-russet-2',
    name: 'Apple - Ard Cairn Russet 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ard Cairn Russet 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ard Cairn Russet 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-ariane-2',
    name: 'Apple - Ariane 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ariane 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ariane 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-aroma-2',
    name: 'Apple - Aroma 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Aroma 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Aroma 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-arthur-turner-2',
    name: 'Apple - Arthur Turner 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Arthur Turner 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arthur Turner 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-ashmeads-kernel-2',
    name: 'Apple - Ashmeads Kernel 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ashmeads Kernel 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ashmeads Kernel 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-aurora-2',
    name: 'Apple - Aurora 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Aurora 2 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Aurora 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-autumn-bough-2',
    name: 'Apple - Autumn Bough 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Bough 2 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Bough 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-autumn-crisp-2',
    name: 'Apple - Autumn Crisp 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Crisp 2 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Crisp 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-autumn-glory-2',
    name: 'Apple - Autumn Glory 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Glory 2 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Glory 2'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-autumn-rose-2',
    name: 'Apple - Autumn Rose 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Autumn Rose 2 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Rose 2'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-baker-2',
    name: 'Apple - Baker 2',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Baker 2 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Baker 2'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-honeycrisp-3',
    name: 'Apple - Honeycrisp 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Honeycrisp 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Honeycrisp 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-gala-3',
    name: 'Apple - Gala 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Gala 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gala 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-fuji-3',
    name: 'Apple - Fuji 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Fuji 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fuji 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-granny-smith-3',
    name: 'Apple - Granny Smith 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Granny Smith 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Granny Smith 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-red-delicious-3',
    name: 'Apple - Red Delicious 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Red Delicious 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Delicious 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-golden-delicious-3',
    name: 'Apple - Golden Delicious 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Golden Delicious 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Golden Delicious 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-mcintosh-3',
    name: 'Apple - McIntosh 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'McIntosh 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['McIntosh 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-jonathan-3',
    name: 'Apple - Jonathan 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonathan 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonathan 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-rome-3',
    name: 'Apple - Rome 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rome 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rome 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-braeburn-3',
    name: 'Apple - Braeburn 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Braeburn 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Braeburn 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pink-lady-3',
    name: 'Apple - Pink Lady 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pink Lady 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pink Lady 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-jazz-3',
    name: 'Apple - Jazz 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jazz 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jazz 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-envy-3',
    name: 'Apple - Envy 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Envy 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Envy 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-opal-3',
    name: 'Apple - Opal 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Opal 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Opal 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-cosmic-crisp-3',
    name: 'Apple - Cosmic Crisp 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cosmic Crisp 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cosmic Crisp 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-sweetango-3',
    name: 'Apple - SweeTango 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'SweeTango 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['SweeTango 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-evercrisp-3',
    name: 'Apple - EverCrisp 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'EverCrisp 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['EverCrisp 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-kanzi-3',
    name: 'Apple - Kanzi 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Kanzi 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kanzi 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pacific-rose-3',
    name: 'Apple - Pacific Rose 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pacific Rose 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pacific Rose 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-lady-alice-3',
    name: 'Apple - Lady Alice 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lady Alice 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lady Alice 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-zestar-3',
    name: 'Apple - Zestar 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Zestar 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Zestar 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-snowsweet-3',
    name: 'Apple - SnowSweet 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'SnowSweet 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['SnowSweet 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-frostbite-3',
    name: 'Apple - Frostbite 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Frostbite 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frostbite 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-haralson-3',
    name: 'Apple - Haralson 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Haralson 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Haralson 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-wealthy-3',
    name: 'Apple - Wealthy 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Wealthy 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Wealthy 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-cortland-3',
    name: 'Apple - Cortland 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cortland 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cortland 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-empire-3',
    name: 'Apple - Empire 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Empire 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Empire 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-macoun-3',
    name: 'Apple - Macoun 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Macoun 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Macoun 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-northern-spy-3',
    name: 'Apple - Northern Spy 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northern Spy 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northern Spy 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-rhode-island-greening-3',
    name: 'Apple - Rhode Island Greening 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Rhode Island Greening 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rhode Island Greening 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-winesap-3',
    name: 'Apple - Winesap 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Winesap 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Winesap 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-stayman-3',
    name: 'Apple - Stayman 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Stayman 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stayman 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-york-imperial-3',
    name: 'Apple - York Imperial 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'York Imperial 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['York Imperial 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-ben-davis-3',
    name: 'Apple - Ben Davis 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ben Davis 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ben Davis 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-arkansas-black-3',
    name: 'Apple - Arkansas Black 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Arkansas Black 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arkansas Black 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-ashmead-kernel-3',
    name: 'Apple - Ashmead Kernel 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ashmead Kernel 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ashmead Kernel 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-baldwin-3',
    name: 'Apple - Baldwin 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Baldwin 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Baldwin 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-bellflower-3',
    name: 'Apple - Bellflower 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Bellflower 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bellflower 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-black-oxford-3',
    name: 'Apple - Black Oxford 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Black Oxford 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Black Oxford 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-blue-pearmain-3',
    name: 'Apple - Blue Pearmain 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Blue Pearmain 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blue Pearmain 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-bramley-seedling-3',
    name: 'Apple - Bramley Seedling 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Bramley Seedling 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bramley Seedling 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-calville-blanc-3',
    name: 'Apple - Calville Blanc 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Calville Blanc 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Calville Blanc 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-cox-orange-pippin-3',
    name: 'Apple - Cox Orange Pippin 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Cox Orange Pippin 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cox Orange Pippin 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-criterion-3',
    name: 'Apple - Criterion 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Criterion 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Criterion 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-delicious-3',
    name: 'Apple - Delicious 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Delicious 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delicious 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-dorsett-golden-3',
    name: 'Apple - Dorsett Golden 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Dorsett Golden 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dorsett Golden 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-egremont-russet-3',
    name: 'Apple - Egremont Russet 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Egremont Russet 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Egremont Russet 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-elstar-3',
    name: 'Apple - Elstar 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Elstar 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elstar 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-enterprise-3',
    name: 'Apple - Enterprise 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Enterprise 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Enterprise 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-esopus-spitzenburg-3',
    name: 'Apple - Esopus Spitzenburg 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Esopus Spitzenburg 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Esopus Spitzenburg 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-fireside-3',
    name: 'Apple - Fireside 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Fireside 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fireside 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-freedom-3',
    name: 'Apple - Freedom 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Freedom 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Freedom 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-freyberg-3',
    name: 'Apple - Freyberg 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Freyberg 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Freyberg 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-ginger-gold-3',
    name: 'Apple - Ginger Gold 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ginger Gold 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ginger Gold 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-goldrush-3',
    name: 'Apple - GoldRush 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'GoldRush 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['GoldRush 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-gravenstein-3',
    name: 'Apple - Gravenstein 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Gravenstein 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gravenstein 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-harrison-3',
    name: 'Apple - Harrison 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Harrison 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrison 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-hawaii-3',
    name: 'Apple - Hawaii 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hawaii 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hawaii 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-hidden-rose-3',
    name: 'Apple - Hidden Rose 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hidden Rose 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hidden Rose 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-hokuto-3',
    name: 'Apple - Hokuto 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hokuto 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hokuto 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-hudson-golden-gem-3',
    name: 'Apple - Hudson Golden Gem 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Hudson Golden Gem 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hudson Golden Gem 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-idared-3',
    name: 'Apple - Idared 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Idared 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Idared 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-initial-3',
    name: 'Apple - Initial 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Initial 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Initial 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-irish-peach-3',
    name: 'Apple - Irish Peach 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Irish Peach 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Irish Peach 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-james-grieve-3',
    name: 'Apple - James Grieve 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'James Grieve 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['James Grieve 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-jersey-mac-3',
    name: 'Apple - Jersey Mac 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jersey Mac 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jersey Mac 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-jonagold-3',
    name: 'Apple - Jonagold 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonagold 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonagold 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-jonamac-3',
    name: 'Apple - Jonamac 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonamac 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonamac 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-jonalicious-3',
    name: 'Apple - Jonalicious 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Jonalicious 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jonalicious 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-juliet-3',
    name: 'Apple - Juliet 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Juliet 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Juliet 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-karmijn-de-sonnaville-3',
    name: 'Apple - Karmijn de Sonnaville 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Karmijn de Sonnaville 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Karmijn de Sonnaville 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-king-david-3',
    name: 'Apple - King David 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'King David 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['King David 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-king-luscious-3',
    name: 'Apple - King Luscious 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'King Luscious 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['King Luscious 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-kidd-orange-red-3',
    name: 'Apple - Kidd Orange Red 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Kidd Orange Red 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kidd Orange Red 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-lady-3',
    name: 'Apple - Lady 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lady 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lady 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-landsberger-reinette-3',
    name: 'Apple - Landsberger Reinette 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Landsberger Reinette 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Landsberger Reinette 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-liberty-3',
    name: 'Apple - Liberty 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Liberty 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Liberty 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-lodi-3',
    name: 'Apple - Lodi 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lodi 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lodi 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-lord-derby-3',
    name: 'Apple - Lord Derby 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Lord Derby 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lord Derby 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-macoun-3',
    name: 'Apple - Macoun 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Macoun 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Macoun 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-magnum-bonum-3',
    name: 'Apple - Magnum Bonum 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Magnum Bonum 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Magnum Bonum 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-maiden-blush-3',
    name: 'Apple - Maiden Blush 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Maiden Blush 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Maiden Blush 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-margil-3',
    name: 'Apple - Margil 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Margil 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Margil 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-melrose-3',
    name: 'Apple - Melrose 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Melrose 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Melrose 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-mollies-delicious-3',
    name: 'Apple - Mollies Delicious 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mollies Delicious 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mollies Delicious 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-mother-3',
    name: 'Apple - Mother 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mother 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mother 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-mutsu-3',
    name: 'Apple - Mutsu 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Mutsu 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mutsu 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-newtown-pippin-3',
    name: 'Apple - Newtown Pippin 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Newtown Pippin 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Newtown Pippin 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-newton-3',
    name: 'Apple - Newton 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Newton 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Newton 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-nickajack-3',
    name: 'Apple - Nickajack 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Nickajack 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nickajack 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-northfield-beauty-3',
    name: 'Apple - Northfield Beauty 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northfield Beauty 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northfield Beauty 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-northwest-greening-3',
    name: 'Apple - Northwest Greening 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Northwest Greening 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Northwest Greening 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-nova-easygro-3',
    name: 'Apple - Nova Easygro 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Nova Easygro 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nova Easygro 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-novamac-3',
    name: 'Apple - Novamac 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Novamac 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Novamac 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-oriole-3',
    name: 'Apple - Oriole 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Oriole 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Oriole 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-orleans-reinette-3',
    name: 'Apple - Orleans Reinette 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Orleans Reinette 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Orleans Reinette 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-ozark-gold-3',
    name: 'Apple - Ozark Gold 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Ozark Gold 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ozark Gold 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-paulared-3',
    name: 'Apple - Paulared 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Paulared 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Paulared 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pepin-spicy-3',
    name: 'Apple - Pepin Spicy 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pepin Spicy 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pepin Spicy 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pineapple-3',
    name: 'Apple - Pineapple 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pineapple 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pineapple 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-pioneer-mac-3',
    name: 'Apple - Pioneer Mac 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pioneer Mac 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pioneer Mac 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pitmaston-pineapple-3',
    name: 'Apple - Pitmaston Pineapple 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pitmaston Pineapple 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pitmaston Pineapple 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-pomme-gris-3',
    name: 'Apple - Pomme Gris 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pomme Gris 3 apple. Multi-purpose apple, good for fresh or cooking. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pomme Gris 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-porter-3',
    name: 'Apple - Porter 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Porter 3 apple. Excellent fresh eating apple, crisp and sweet. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Porter 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pound-sweet-3',
    name: 'Apple - Pound Sweet 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pound Sweet 3 apple. Great for baking and cooking, holds shape well. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pound Sweet 3'],
    uses: ['baking', 'pies', 'sauce']
  },
  {
    id: 'apple-prima-3',
    name: 'Apple - Prima 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Prima 3 apple. Multi-purpose apple, good for fresh or cooking. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Prima 3'],
    uses: ['fresh', 'cooking', 'cider']
  },
  {
    id: 'apple-priscilla-3',
    name: 'Apple - Priscilla 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Priscilla 3 apple. Excellent fresh eating apple, crisp and sweet. Needs pollinator variety for best fruit set.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Priscilla 3'],
    uses: ['fresh', 'eating', 'salads']
  },
  {
    id: 'apple-pristine-3',
    name: 'Apple - Pristine 3',
    scientificName: 'Malus domestica',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic', 'nasturtium'],
    enemies: ['potato'],
    description: 'Pristine 3 apple. Great for baking and cooking, holds shape well. Partially self-fertile.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pristine 3'],
    uses: ['baking', 'pies', 'sauce']
  }
,
  {
    id: 'peach-elberta',
    name: 'Peach - Elberta',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Elberta peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elberta'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-georgia-belle',
    name: 'Plum - Georgia Belle',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Georgia Belle plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Georgia Belle'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-redhaven',
    name: 'Cherry - Redhaven',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redhaven cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redhaven'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-halehaven',
    name: 'Apricot - Halehaven',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Halehaven apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Halehaven'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-frost',
    name: 'Nectarine - Frost',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Frost nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frost'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-reliance',
    name: 'Peach - Reliance',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Reliance peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Reliance'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-contender',
    name: 'Plum - Contender',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Contender plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Contender'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-madison',
    name: 'Cherry - Madison',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Madison cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Madison'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-redskin',
    name: 'Apricot - Redskin',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redskin apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redskin'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-veteran',
    name: 'Nectarine - Veteran',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Veteran nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Veteran'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-golden-jubilee',
    name: 'Peach - Golden Jubilee',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Golden Jubilee peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Golden Jubilee'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-rio-oso-gem',
    name: 'Plum - Rio Oso Gem',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rio Oso Gem plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rio Oso Gem'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-o-henry',
    name: 'Cherry - O-Henry',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'O-Henry cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['O-Henry'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-autumn-prince',
    name: 'Apricot - Autumn Prince',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Autumn Prince apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Prince'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-cresthaven',
    name: 'Nectarine - Cresthaven',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Cresthaven nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cresthaven'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-glohaven',
    name: 'Peach - Glohaven',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Glohaven peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Glohaven'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-harken',
    name: 'Plum - Harken',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harken plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harken'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-loring',
    name: 'Cherry - Loring',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Loring cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Loring'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-sunhaven',
    name: 'Apricot - Sunhaven',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sunhaven apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunhaven'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-santa-rosa',
    name: 'Nectarine - Santa Rosa',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Santa Rosa nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Santa Rosa'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-methley',
    name: 'Peach - Methley',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Methley peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Methley'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-stanley',
    name: 'Plum - Stanley',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stanley plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stanley'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-damson',
    name: 'Cherry - Damson',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Damson cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Damson'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-italian',
    name: 'Apricot - Italian',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Italian apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Italian'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-green-gage',
    name: 'Nectarine - Green Gage',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Green Gage nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Green Gage'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-yellow-egg',
    name: 'Peach - Yellow Egg',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Yellow Egg peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Egg'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-victoria',
    name: 'Plum - Victoria',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Victoria plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Victoria'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-moyer',
    name: 'Cherry - Moyer',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moyer cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moyer'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-satsuma',
    name: 'Apricot - Satsuma',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Satsuma apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Satsuma'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-bing',
    name: 'Nectarine - Bing',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Bing nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bing'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-rainier',
    name: 'Peach - Rainier',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rainier peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rainier'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-montmorency',
    name: 'Plum - Montmorency',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Montmorency plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Montmorency'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-stella',
    name: 'Cherry - Stella',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stella cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stella'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-lapins',
    name: 'Apricot - Lapins',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Lapins apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lapins'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-sweetheart',
    name: 'Nectarine - Sweetheart',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sweetheart nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sweetheart'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-chelan',
    name: 'Peach - Chelan',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chelan peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chelan'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-tieton',
    name: 'Plum - Tieton',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tieton plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tieton'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-skeena',
    name: 'Cherry - Skeena',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Skeena cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Skeena'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-regina',
    name: 'Apricot - Regina',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Regina apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Regina'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-moorpark',
    name: 'Nectarine - Moorpark',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moorpark nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moorpark'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-blenheim',
    name: 'Peach - Blenheim',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Blenheim peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blenheim'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-royal',
    name: 'Plum - Royal',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Royal plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Royal'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-tilton',
    name: 'Cherry - Tilton',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tilton cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tilton'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-chinese',
    name: 'Apricot - Chinese',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chinese apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chinese'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-goldcot',
    name: 'Nectarine - Goldcot',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldcot nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldcot'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-hargrand',
    name: 'Peach - Hargrand',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hargrand peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hargrand'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-harogen',
    name: 'Plum - Harogen',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harogen plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harogen'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-harglow',
    name: 'Cherry - Harglow',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harglow cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harglow'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-puget-gold',
    name: 'Apricot - Puget Gold',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Puget Gold apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Puget Gold'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-fantasia',
    name: 'Nectarine - Fantasia',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fantasia nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fantasia'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-fairlane',
    name: 'Peach - Fairlane',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fairlane peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fairlane'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-flavortop',
    name: 'Plum - Flavortop',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Flavortop plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Flavortop'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-goldmine',
    name: 'Cherry - Goldmine',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldmine cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldmine'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-hardired',
    name: 'Apricot - Hardired',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hardired apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hardired'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-independence',
    name: 'Nectarine - Independence',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Independence nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Independence'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-mericrest',
    name: 'Peach - Mericrest',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Mericrest peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mericrest'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-nectared',
    name: 'Plum - Nectared',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectared plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectared'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-panamint',
    name: 'Cherry - Panamint',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Panamint cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Panamint'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-redgold',
    name: 'Apricot - Redgold',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redgold apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redgold'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-sunred',
    name: 'Nectarine - Sunred',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sunred nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunred'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-arctic-star',
    name: 'Peach - Arctic Star',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Star peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Star'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-arctic-glo',
    name: 'Plum - Arctic Glo',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Glo plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Glo'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-arctic-jay',
    name: 'Cherry - Arctic Jay',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Jay cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Jay'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-arctic-rose',
    name: 'Apricot - Arctic Rose',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Rose apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Rose'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-arctic-sprite',
    name: 'Nectarine - Arctic Sprite',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Sprite nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Sprite'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-desert-dawn',
    name: 'Peach - Desert Dawn',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Dawn peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Dawn'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-desert-delight',
    name: 'Plum - Desert Delight',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Delight plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Delight'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-desert-ray',
    name: 'Cherry - Desert Ray',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Ray cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Ray'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-double-delight',
    name: 'Apricot - Double Delight',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Double Delight apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Double Delight'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-fire-sweet',
    name: 'Nectarine - Fire Sweet',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fire Sweet nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fire Sweet'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-heavenly-white',
    name: 'Peach - Heavenly White',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Heavenly White peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Heavenly White'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-honey-kist',
    name: 'Plum - Honey Kist',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Honey Kist plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Honey Kist'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-nectafest',
    name: 'Cherry - Nectafest',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectafest cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectafest'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-nectared',
    name: 'Apricot - Nectared',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectared apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectared'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-rose-diamond',
    name: 'Nectarine - Rose Diamond',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rose Diamond nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rose Diamond'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-ruby-sweet',
    name: 'Peach - Ruby Sweet',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Ruby Sweet peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ruby Sweet'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-sauzee-king',
    name: 'Plum - Sauzee King',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sauzee King plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sauzee King'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-snow-queen',
    name: 'Cherry - Snow Queen',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Snow Queen cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Snow Queen'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-spice-zee',
    name: 'Apricot - Spice Zee',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Spice Zee apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spice Zee'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-summer-beaut',
    name: 'Nectarine - Summer Beaut',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Summer Beaut nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Beaut'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-summer-fire',
    name: 'Peach - Summer Fire',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Summer Fire peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Fire'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-elberta-2',
    name: 'Plum - Elberta 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Elberta 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elberta 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-georgia-belle-2',
    name: 'Cherry - Georgia Belle 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Georgia Belle 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Georgia Belle 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-redhaven-2',
    name: 'Apricot - Redhaven 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redhaven 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redhaven 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-halehaven-2',
    name: 'Nectarine - Halehaven 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Halehaven 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Halehaven 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-frost-2',
    name: 'Peach - Frost 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Frost 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frost 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-reliance-2',
    name: 'Plum - Reliance 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Reliance 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Reliance 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-contender-2',
    name: 'Cherry - Contender 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Contender 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Contender 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-madison-2',
    name: 'Apricot - Madison 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Madison 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Madison 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-redskin-2',
    name: 'Nectarine - Redskin 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redskin 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redskin 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-veteran-2',
    name: 'Peach - Veteran 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Veteran 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Veteran 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-golden-jubilee-2',
    name: 'Plum - Golden Jubilee 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Golden Jubilee 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Golden Jubilee 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-rio-oso-gem-2',
    name: 'Cherry - Rio Oso Gem 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rio Oso Gem 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rio Oso Gem 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-o-henry-2',
    name: 'Apricot - O-Henry 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'O-Henry 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['O-Henry 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-autumn-prince-2',
    name: 'Nectarine - Autumn Prince 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Autumn Prince 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Prince 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-cresthaven-2',
    name: 'Peach - Cresthaven 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Cresthaven 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cresthaven 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-glohaven-2',
    name: 'Plum - Glohaven 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Glohaven 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Glohaven 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-harken-2',
    name: 'Cherry - Harken 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harken 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harken 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-loring-2',
    name: 'Apricot - Loring 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Loring 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Loring 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-sunhaven-2',
    name: 'Nectarine - Sunhaven 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sunhaven 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunhaven 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-santa-rosa-2',
    name: 'Peach - Santa Rosa 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Santa Rosa 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Santa Rosa 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-methley-2',
    name: 'Plum - Methley 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Methley 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Methley 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-stanley-2',
    name: 'Cherry - Stanley 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stanley 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stanley 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-damson-2',
    name: 'Apricot - Damson 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Damson 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Damson 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-italian-2',
    name: 'Nectarine - Italian 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Italian 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Italian 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-green-gage-2',
    name: 'Peach - Green Gage 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Green Gage 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Green Gage 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-yellow-egg-2',
    name: 'Plum - Yellow Egg 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Yellow Egg 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Egg 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-victoria-2',
    name: 'Cherry - Victoria 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Victoria 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Victoria 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-moyer-2',
    name: 'Apricot - Moyer 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moyer 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moyer 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-satsuma-2',
    name: 'Nectarine - Satsuma 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Satsuma 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Satsuma 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-bing-2',
    name: 'Peach - Bing 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Bing 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bing 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-rainier-2',
    name: 'Plum - Rainier 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rainier 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rainier 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-montmorency-2',
    name: 'Cherry - Montmorency 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Montmorency 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Montmorency 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-stella-2',
    name: 'Apricot - Stella 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stella 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stella 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-lapins-2',
    name: 'Nectarine - Lapins 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Lapins 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lapins 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-sweetheart-2',
    name: 'Peach - Sweetheart 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sweetheart 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sweetheart 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-chelan-2',
    name: 'Plum - Chelan 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chelan 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chelan 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-tieton-2',
    name: 'Cherry - Tieton 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tieton 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tieton 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-skeena-2',
    name: 'Apricot - Skeena 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Skeena 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Skeena 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-regina-2',
    name: 'Nectarine - Regina 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Regina 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Regina 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-moorpark-2',
    name: 'Peach - Moorpark 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moorpark 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moorpark 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-blenheim-2',
    name: 'Plum - Blenheim 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Blenheim 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blenheim 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-royal-2',
    name: 'Cherry - Royal 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Royal 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Royal 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-tilton-2',
    name: 'Apricot - Tilton 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tilton 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tilton 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-chinese-2',
    name: 'Nectarine - Chinese 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chinese 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chinese 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-goldcot-2',
    name: 'Peach - Goldcot 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldcot 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldcot 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-hargrand-2',
    name: 'Plum - Hargrand 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hargrand 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hargrand 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-harogen-2',
    name: 'Cherry - Harogen 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harogen 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harogen 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-harglow-2',
    name: 'Apricot - Harglow 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harglow 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harglow 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-puget-gold-2',
    name: 'Nectarine - Puget Gold 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Puget Gold 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Puget Gold 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-fantasia-2',
    name: 'Peach - Fantasia 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fantasia 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fantasia 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-fairlane-2',
    name: 'Plum - Fairlane 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fairlane 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fairlane 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-flavortop-2',
    name: 'Cherry - Flavortop 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Flavortop 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Flavortop 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-goldmine-2',
    name: 'Apricot - Goldmine 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldmine 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldmine 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-hardired-2',
    name: 'Nectarine - Hardired 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hardired 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hardired 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-independence-2',
    name: 'Peach - Independence 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Independence 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Independence 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-mericrest-2',
    name: 'Plum - Mericrest 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Mericrest 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mericrest 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-nectared-2',
    name: 'Cherry - Nectared 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectared 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectared 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-panamint-2',
    name: 'Apricot - Panamint 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Panamint 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Panamint 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-redgold-2',
    name: 'Nectarine - Redgold 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redgold 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redgold 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-sunred-2',
    name: 'Peach - Sunred 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sunred 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunred 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-arctic-star-2',
    name: 'Plum - Arctic Star 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Star 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Star 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-arctic-glo-2',
    name: 'Cherry - Arctic Glo 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Glo 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Glo 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-arctic-jay-2',
    name: 'Apricot - Arctic Jay 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Jay 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Jay 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-arctic-rose-2',
    name: 'Nectarine - Arctic Rose 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Rose 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Rose 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-arctic-sprite-2',
    name: 'Peach - Arctic Sprite 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Sprite 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Sprite 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-desert-dawn-2',
    name: 'Plum - Desert Dawn 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Dawn 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Dawn 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-desert-delight-2',
    name: 'Cherry - Desert Delight 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Delight 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Delight 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-desert-ray-2',
    name: 'Apricot - Desert Ray 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Ray 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Ray 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-double-delight-2',
    name: 'Nectarine - Double Delight 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Double Delight 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Double Delight 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-fire-sweet-2',
    name: 'Peach - Fire Sweet 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fire Sweet 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fire Sweet 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-heavenly-white-2',
    name: 'Plum - Heavenly White 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Heavenly White 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Heavenly White 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-honey-kist-2',
    name: 'Cherry - Honey Kist 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Honey Kist 2 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Honey Kist 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-nectafest-2',
    name: 'Apricot - Nectafest 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectafest 2 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectafest 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-nectared-2',
    name: 'Nectarine - Nectared 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectared 2 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectared 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-rose-diamond-2',
    name: 'Peach - Rose Diamond 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rose Diamond 2 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rose Diamond 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-ruby-sweet-2',
    name: 'Plum - Ruby Sweet 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Ruby Sweet 2 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ruby Sweet 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-sauzee-king-2',
    name: 'Cherry - Sauzee King 2',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sauzee King 2 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sauzee King 2'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-snow-queen-2',
    name: 'Apricot - Snow Queen 2',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Snow Queen 2 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Snow Queen 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-spice-zee-2',
    name: 'Nectarine - Spice Zee 2',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Spice Zee 2 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spice Zee 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-summer-beaut-2',
    name: 'Peach - Summer Beaut 2',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Summer Beaut 2 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Beaut 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-summer-fire-2',
    name: 'Plum - Summer Fire 2',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Summer Fire 2 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Fire 2'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-elberta-3',
    name: 'Cherry - Elberta 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Elberta 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elberta 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-georgia-belle-3',
    name: 'Apricot - Georgia Belle 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Georgia Belle 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Georgia Belle 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-redhaven-3',
    name: 'Nectarine - Redhaven 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redhaven 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redhaven 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-halehaven-3',
    name: 'Peach - Halehaven 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Halehaven 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Halehaven 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-frost-3',
    name: 'Plum - Frost 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Frost 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frost 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-reliance-3',
    name: 'Cherry - Reliance 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Reliance 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Reliance 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-contender-3',
    name: 'Apricot - Contender 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Contender 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Contender 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-madison-3',
    name: 'Nectarine - Madison 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Madison 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Madison 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-redskin-3',
    name: 'Peach - Redskin 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redskin 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redskin 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-veteran-3',
    name: 'Plum - Veteran 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Veteran 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Veteran 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-golden-jubilee-3',
    name: 'Cherry - Golden Jubilee 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Golden Jubilee 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Golden Jubilee 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-rio-oso-gem-3',
    name: 'Apricot - Rio Oso Gem 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rio Oso Gem 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rio Oso Gem 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-o-henry-3',
    name: 'Nectarine - O-Henry 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'O-Henry 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['O-Henry 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-autumn-prince-3',
    name: 'Peach - Autumn Prince 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Autumn Prince 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Prince 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-cresthaven-3',
    name: 'Plum - Cresthaven 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Cresthaven 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cresthaven 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-glohaven-3',
    name: 'Cherry - Glohaven 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Glohaven 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Glohaven 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-harken-3',
    name: 'Apricot - Harken 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harken 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harken 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-loring-3',
    name: 'Nectarine - Loring 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Loring 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Loring 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-sunhaven-3',
    name: 'Peach - Sunhaven 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sunhaven 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunhaven 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-santa-rosa-3',
    name: 'Plum - Santa Rosa 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Santa Rosa 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Santa Rosa 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-methley-3',
    name: 'Cherry - Methley 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Methley 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Methley 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-stanley-3',
    name: 'Apricot - Stanley 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stanley 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stanley 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-damson-3',
    name: 'Nectarine - Damson 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Damson 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Damson 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-italian-3',
    name: 'Peach - Italian 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Italian 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Italian 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-green-gage-3',
    name: 'Plum - Green Gage 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Green Gage 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Green Gage 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-yellow-egg-3',
    name: 'Cherry - Yellow Egg 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Yellow Egg 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Egg 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-victoria-3',
    name: 'Apricot - Victoria 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Victoria 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Victoria 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-moyer-3',
    name: 'Nectarine - Moyer 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moyer 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moyer 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-satsuma-3',
    name: 'Peach - Satsuma 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Satsuma 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Satsuma 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-bing-3',
    name: 'Plum - Bing 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Bing 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bing 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-rainier-3',
    name: 'Cherry - Rainier 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rainier 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rainier 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-montmorency-3',
    name: 'Apricot - Montmorency 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Montmorency 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Montmorency 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-stella-3',
    name: 'Nectarine - Stella 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stella 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stella 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-lapins-3',
    name: 'Peach - Lapins 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Lapins 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lapins 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-sweetheart-3',
    name: 'Plum - Sweetheart 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sweetheart 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sweetheart 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-chelan-3',
    name: 'Cherry - Chelan 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chelan 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chelan 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-tieton-3',
    name: 'Apricot - Tieton 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tieton 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tieton 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-skeena-3',
    name: 'Nectarine - Skeena 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Skeena 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Skeena 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-regina-3',
    name: 'Peach - Regina 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Regina 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Regina 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-moorpark-3',
    name: 'Plum - Moorpark 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moorpark 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moorpark 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-blenheim-3',
    name: 'Cherry - Blenheim 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Blenheim 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blenheim 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-royal-3',
    name: 'Apricot - Royal 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Royal 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Royal 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-tilton-3',
    name: 'Nectarine - Tilton 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tilton 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tilton 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-chinese-3',
    name: 'Peach - Chinese 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chinese 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chinese 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-goldcot-3',
    name: 'Plum - Goldcot 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldcot 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldcot 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-hargrand-3',
    name: 'Cherry - Hargrand 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hargrand 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hargrand 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-harogen-3',
    name: 'Apricot - Harogen 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harogen 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harogen 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-harglow-3',
    name: 'Nectarine - Harglow 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harglow 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harglow 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-puget-gold-3',
    name: 'Peach - Puget Gold 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Puget Gold 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Puget Gold 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-fantasia-3',
    name: 'Plum - Fantasia 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fantasia 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fantasia 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-fairlane-3',
    name: 'Cherry - Fairlane 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fairlane 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fairlane 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-flavortop-3',
    name: 'Apricot - Flavortop 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Flavortop 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Flavortop 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-goldmine-3',
    name: 'Nectarine - Goldmine 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldmine 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldmine 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-hardired-3',
    name: 'Peach - Hardired 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hardired 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hardired 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-independence-3',
    name: 'Plum - Independence 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Independence 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Independence 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-mericrest-3',
    name: 'Cherry - Mericrest 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Mericrest 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mericrest 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-nectared-3',
    name: 'Apricot - Nectared 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectared 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectared 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-panamint-3',
    name: 'Nectarine - Panamint 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Panamint 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Panamint 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-redgold-3',
    name: 'Peach - Redgold 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redgold 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redgold 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-sunred-3',
    name: 'Plum - Sunred 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sunred 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunred 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-arctic-star-3',
    name: 'Cherry - Arctic Star 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Star 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Star 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-arctic-glo-3',
    name: 'Apricot - Arctic Glo 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Glo 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Glo 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-arctic-jay-3',
    name: 'Nectarine - Arctic Jay 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Jay 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Jay 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-arctic-rose-3',
    name: 'Peach - Arctic Rose 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Rose 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Rose 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-arctic-sprite-3',
    name: 'Plum - Arctic Sprite 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Arctic Sprite 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arctic Sprite 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-desert-dawn-3',
    name: 'Cherry - Desert Dawn 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Dawn 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Dawn 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-desert-delight-3',
    name: 'Apricot - Desert Delight 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Delight 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Delight 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-desert-ray-3',
    name: 'Nectarine - Desert Ray 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Desert Ray 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Desert Ray 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-double-delight-3',
    name: 'Peach - Double Delight 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Double Delight 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Double Delight 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-fire-sweet-3',
    name: 'Plum - Fire Sweet 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fire Sweet 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fire Sweet 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-heavenly-white-3',
    name: 'Cherry - Heavenly White 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Heavenly White 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Heavenly White 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-honey-kist-3',
    name: 'Apricot - Honey Kist 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Honey Kist 3 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Honey Kist 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-nectafest-3',
    name: 'Nectarine - Nectafest 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectafest 3 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectafest 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-nectared-3',
    name: 'Peach - Nectared 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectared 3 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectared 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-rose-diamond-3',
    name: 'Plum - Rose Diamond 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rose Diamond 3 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rose Diamond 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-ruby-sweet-3',
    name: 'Cherry - Ruby Sweet 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Ruby Sweet 3 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ruby Sweet 3'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-sauzee-king-3',
    name: 'Apricot - Sauzee King 3',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sauzee King 3 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sauzee King 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-snow-queen-3',
    name: 'Nectarine - Snow Queen 3',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Snow Queen 3 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Snow Queen 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-spice-zee-3',
    name: 'Peach - Spice Zee 3',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Spice Zee 3 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spice Zee 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-summer-beaut-3',
    name: 'Plum - Summer Beaut 3',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Summer Beaut 3 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Beaut 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-summer-fire-3',
    name: 'Cherry - Summer Fire 3',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Summer Fire 3 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summer Fire 3'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-elberta-4',
    name: 'Apricot - Elberta 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Elberta 4 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elberta 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-georgia-belle-4',
    name: 'Nectarine - Georgia Belle 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Georgia Belle 4 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Georgia Belle 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-redhaven-4',
    name: 'Peach - Redhaven 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redhaven 4 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redhaven 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-halehaven-4',
    name: 'Plum - Halehaven 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Halehaven 4 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Halehaven 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-frost-4',
    name: 'Cherry - Frost 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Frost 4 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frost 4'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-reliance-4',
    name: 'Apricot - Reliance 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Reliance 4 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Reliance 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-contender-4',
    name: 'Nectarine - Contender 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Contender 4 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Contender 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-madison-4',
    name: 'Peach - Madison 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Madison 4 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Madison 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-redskin-4',
    name: 'Plum - Redskin 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Redskin 4 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Redskin 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-veteran-4',
    name: 'Cherry - Veteran 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Veteran 4 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Veteran 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-golden-jubilee-4',
    name: 'Apricot - Golden Jubilee 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Golden Jubilee 4 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Golden Jubilee 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-rio-oso-gem-4',
    name: 'Nectarine - Rio Oso Gem 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rio Oso Gem 4 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rio Oso Gem 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-o-henry-4',
    name: 'Peach - O-Henry 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'O-Henry 4 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['O-Henry 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-autumn-prince-4',
    name: 'Plum - Autumn Prince 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Autumn Prince 4 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Prince 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-cresthaven-4',
    name: 'Cherry - Cresthaven 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Cresthaven 4 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cresthaven 4'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-glohaven-4',
    name: 'Apricot - Glohaven 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Glohaven 4 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Glohaven 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-harken-4',
    name: 'Nectarine - Harken 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harken 4 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harken 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-loring-4',
    name: 'Peach - Loring 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Loring 4 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Loring 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-sunhaven-4',
    name: 'Plum - Sunhaven 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sunhaven 4 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sunhaven 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-santa-rosa-4',
    name: 'Cherry - Santa Rosa 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Santa Rosa 4 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Santa Rosa 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-methley-4',
    name: 'Apricot - Methley 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Methley 4 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Methley 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-stanley-4',
    name: 'Nectarine - Stanley 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stanley 4 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stanley 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-damson-4',
    name: 'Peach - Damson 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Damson 4 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Damson 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-italian-4',
    name: 'Plum - Italian 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Italian 4 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Italian 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-green-gage-4',
    name: 'Cherry - Green Gage 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Green Gage 4 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Green Gage 4'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-yellow-egg-4',
    name: 'Apricot - Yellow Egg 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Yellow Egg 4 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yellow Egg 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-victoria-4',
    name: 'Nectarine - Victoria 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Victoria 4 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Victoria 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-moyer-4',
    name: 'Peach - Moyer 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moyer 4 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moyer 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-satsuma-4',
    name: 'Plum - Satsuma 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Satsuma 4 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Satsuma 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-bing-4',
    name: 'Cherry - Bing 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Bing 4 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bing 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-rainier-4',
    name: 'Apricot - Rainier 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Rainier 4 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rainier 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-montmorency-4',
    name: 'Nectarine - Montmorency 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Montmorency 4 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Montmorency 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-stella-4',
    name: 'Peach - Stella 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Stella 4 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Stella 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-lapins-4',
    name: 'Plum - Lapins 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Lapins 4 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lapins 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-sweetheart-4',
    name: 'Cherry - Sweetheart 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Sweetheart 4 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Sweetheart 4'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-chelan-4',
    name: 'Apricot - Chelan 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chelan 4 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chelan 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-tieton-4',
    name: 'Nectarine - Tieton 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tieton 4 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tieton 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-skeena-4',
    name: 'Peach - Skeena 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Skeena 4 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Skeena 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-regina-4',
    name: 'Plum - Regina 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Regina 4 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Regina 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-moorpark-4',
    name: 'Cherry - Moorpark 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Moorpark 4 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moorpark 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-blenheim-4',
    name: 'Apricot - Blenheim 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Blenheim 4 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blenheim 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-royal-4',
    name: 'Nectarine - Royal 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Royal 4 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Royal 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-tilton-4',
    name: 'Peach - Tilton 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Tilton 4 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tilton 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-chinese-4',
    name: 'Plum - Chinese 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Chinese 4 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chinese 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-goldcot-4',
    name: 'Cherry - Goldcot 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldcot 4 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldcot 4'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-hargrand-4',
    name: 'Apricot - Hargrand 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hargrand 4 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hargrand 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-harogen-4',
    name: 'Nectarine - Harogen 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harogen 4 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harogen 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-harglow-4',
    name: 'Peach - Harglow 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Harglow 4 peach. Juicy and sweet, perfect for fresh eating or canning. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harglow 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-puget-gold-4',
    name: 'Plum - Puget Gold 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Puget Gold 4 plum. Sweet-tart flavor, excellent for jam or fresh. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Puget Gold 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-fantasia-4',
    name: 'Cherry - Fantasia 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fantasia 4 cherry. Sweet or tart varieties for fresh or pie. Needs pollinator.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fantasia 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'apricot-fairlane-4',
    name: 'Apricot - Fairlane 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Fairlane 4 apricot. Fragrant and sweet, early summer fruit. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fairlane 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-flavortop-4',
    name: 'Nectarine - Flavortop 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Flavortop 4 nectarine. Smooth-skinned peach, intense flavor. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Flavortop 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'peach-goldmine-4',
    name: 'Peach - Goldmine 4',
    scientificName: 'Prunus persica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Goldmine 4 peach. Juicy and sweet, perfect for fresh eating or canning. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Goldmine 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'plum-hardired-4',
    name: 'Plum - Hardired 4',
    scientificName: 'Prunus domestica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Hardired 4 plum. Sweet-tart flavor, excellent for jam or fresh. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hardired 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'cherry-independence-4',
    name: 'Cherry - Independence 4',
    scientificName: 'Prunus avium',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Independence 4 cherry. Sweet or tart varieties for fresh or pie. Self-fertile.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Independence 4'],
    uses: ['pie', 'preserves', 'canning']
  },
  {
    id: 'apricot-mericrest-4',
    name: 'Apricot - Mericrest 4',
    scientificName: 'Prunus armeniaca',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Mericrest 4 apricot. Fragrant and sweet, early summer fruit. Needs pollinator.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Mericrest 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  },
  {
    id: 'nectarine-nectared-4',
    name: 'Nectarine - Nectared 4',
    scientificName: 'Prunus persica var. nucipersica',
    category: 'tree',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: ['tomato'],
    description: 'Nectared 4 nectarine. Smooth-skinned peach, intense flavor. Self-fertile.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nectared 4'],
    uses: ['fresh', 'canning', 'baking', 'drying']
  }
,
  {
    id: 'pear-bartlett',
    name: 'Pear - Bartlett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bartlett pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bartlett'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-bosc',
    name: 'Pear - Bosc',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bosc pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bosc'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-anjou',
    name: 'Pear - Anjou',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Anjou pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Anjou'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-comice',
    name: 'Pear - Comice',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Comice pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Comice'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-seckel',
    name: 'Pear - Seckel',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Seckel pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Seckel'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-concorde',
    name: 'Pear - Concorde',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Concorde pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Concorde'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-forelle',
    name: 'Pear - Forelle',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Forelle pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Forelle'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-red-bartlett',
    name: 'Pear - Red Bartlett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Red Bartlett pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Bartlett'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-green-anjou',
    name: 'Pear - Green Anjou',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Green Anjou pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Green Anjou'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-red-anjou',
    name: 'Pear - Red Anjou',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Red Anjou pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Anjou'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-danjou',
    name: 'Pear - DAnjou',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'DAnjou pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['DAnjou'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-packham',
    name: 'Pear - Packham',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Packham pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Packham'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-abate-fetel',
    name: 'Pear - Abate Fetel',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Abate Fetel pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Abate Fetel'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-magness',
    name: 'Pear - Magness',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Magness pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Magness'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-moonglow',
    name: 'Pear - Moonglow',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Moonglow pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moonglow'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-harrow-sweet',
    name: 'Pear - Harrow Sweet',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Sweet pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Sweet'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-harrow-delight',
    name: 'Pear - Harrow Delight',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Delight pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Delight'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-harrow-crisp',
    name: 'Pear - Harrow Crisp',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Crisp pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Crisp'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-harrow-gold',
    name: 'Pear - Harrow Gold',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Gold pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Gold'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-harrow-sun',
    name: 'Pear - Harrow Sun',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Sun pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Sun'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-potomac',
    name: 'Pear - Potomac',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Potomac pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Potomac'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-shenandoah',
    name: 'Pear - Shenandoah',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Shenandoah pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Shenandoah'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-ayers',
    name: 'Pear - Ayers',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ayers pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ayers'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-warren',
    name: 'Pear - Warren',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Warren pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Warren'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-kieffer',
    name: 'Pear - Kieffer',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Kieffer pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kieffer'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-orient',
    name: 'Pear - Orient',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Orient pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Orient'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-le-conte',
    name: 'Pear - Le Conte',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Le Conte pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Le Conte'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-maxine',
    name: 'Pear - Maxine',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Maxine pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Maxine'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-starking-delicious',
    name: 'Pear - Starking Delicious',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Starking Delicious pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Starking Delicious'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-bosc',
    name: 'Pear - Beurre Bosc',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Bosc pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Bosc'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-danjou',
    name: 'Pear - Beurre dAnjou',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dAnjou pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dAnjou'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-hardy',
    name: 'Pear - Beurre Hardy',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Hardy pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Hardy'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-superfin',
    name: 'Pear - Beurre Superfin',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Superfin pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Superfin'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-bristol-cross',
    name: 'Pear - Bristol Cross',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bristol Cross pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bristol Cross'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-butirra-precoce-morettini',
    name: 'Pear - Butirra Precoce Morettini',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Butirra Precoce Morettini pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Butirra Precoce Morettini'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-clapps-favorite',
    name: 'Pear - Clapps Favorite',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clapps Favorite pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clapps Favorite'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-clapps-red',
    name: 'Pear - Clapps Red',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clapps Red pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clapps Red'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-conference',
    name: 'Pear - Conference',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Conference pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Conference'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-doyenne-du-comice',
    name: 'Pear - Doyenne du Comice',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne du Comice pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne du Comice'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-dr-jules-guyot',
    name: 'Pear - Dr Jules Guyot',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dr Jules Guyot pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dr Jules Guyot'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-duchess',
    name: 'Pear - Duchess',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchess pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchess'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-flemish-beauty',
    name: 'Pear - Flemish Beauty',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Flemish Beauty pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Flemish Beauty'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-gorham',
    name: 'Pear - Gorham',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Gorham pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gorham'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-hood',
    name: 'Pear - Hood',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hood pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hood'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-hosui',
    name: 'Pear - Hosui',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hosui pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hosui'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-kikusui',
    name: 'Pear - Kikusui',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Kikusui pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kikusui'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-luscious',
    name: 'Pear - Luscious',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Luscious pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Luscious'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-nova',
    name: 'Pear - Nova',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Nova pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nova'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-parker',
    name: 'Pear - Parker',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Parker pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Parker'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-paragon',
    name: 'Pear - Paragon',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Paragon pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Paragon'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-pineapple',
    name: 'Pear - Pineapple',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Pineapple pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pineapple'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-rousselet',
    name: 'Pear - Rousselet',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Rousselet pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rousselet'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-santa-maria',
    name: 'Pear - Santa Maria',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Santa Maria pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Santa Maria'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-shinseiki',
    name: 'Pear - Shinseiki',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Shinseiki pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Shinseiki'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-spalding',
    name: 'Pear - Spalding',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Spalding pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spalding'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-spartlett',
    name: 'Pear - Spartlett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Spartlett pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spartlett'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-summercrisp',
    name: 'Pear - Summercrisp',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Summercrisp pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summercrisp'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-surecrop',
    name: 'Pear - Surecrop',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Surecrop pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Surecrop'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-tsu-li',
    name: 'Pear - Tsu Li',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Tsu Li pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tsu Li'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-20th-century',
    name: 'Pear - 20th Century',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: '20th Century pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['20th Century'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-ya-li',
    name: 'Pear - Ya Li',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ya Li pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ya Li'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-yoinashi',
    name: 'Pear - Yoinashi',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Yoinashi pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yoinashi'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-ambrosia',
    name: 'Pear - Ambrosia',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ambrosia pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ambrosia'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-angelys',
    name: 'Pear - Angelys',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Angelys pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Angelys'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-arromagnac',
    name: 'Pear - Arromagnac',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Arromagnac pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arromagnac'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-autumn-bartlett',
    name: 'Pear - Autumn Bartlett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Autumn Bartlett pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Bartlett'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-baldwin',
    name: 'Pear - Baldwin',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Baldwin pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Baldwin'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-barnett',
    name: 'Pear - Barnett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Barnett pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Barnett'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-giffard',
    name: 'Pear - Beurre Giffard',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Giffard pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Giffard'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-gris',
    name: 'Pear - Beurre Gris',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Gris pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Gris'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-darenberg',
    name: 'Pear - Beurre dArenberg',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dArenberg pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dArenberg'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-de-merode',
    name: 'Pear - Beurre de Merode',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre de Merode pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre de Merode'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-depine',
    name: 'Pear - Beurre dEpine',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dEpine pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dEpine'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-dhardenpont',
    name: 'Pear - Beurre dHardenpont',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dHardenpont pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dHardenpont'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-de-capiaumont',
    name: 'Pear - Beurre de Capiaumont',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre de Capiaumont pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre de Capiaumont'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-de-rance',
    name: 'Pear - Beurre de Rance',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre de Rance pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre de Rance'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-diel',
    name: 'Pear - Beurre Diel',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Diel pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Diel'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-dumenil',
    name: 'Pear - Beurre Dumenil',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Dumenil pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Dumenil'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-durandeau',
    name: 'Pear - Beurre Durandeau',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Durandeau pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Durandeau'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-duroi',
    name: 'Pear - Beurre Duroi',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Duroi pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Duroi'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-easter',
    name: 'Pear - Beurre Easter',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Easter pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Easter'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-bedford',
    name: 'Pear - Beurre Bedford',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Bedford pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Bedford'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-sterckmans',
    name: 'Pear - Beurre Sterckmans',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Sterckmans pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Sterckmans'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-treyve',
    name: 'Pear - Beurre Treyve',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Treyve pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Treyve'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-van-mons',
    name: 'Pear - Beurre Van Mons',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Van Mons pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Van Mons'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-vidal',
    name: 'Pear - Beurre Vidal',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Vidal pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Vidal'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beth',
    name: 'Pear - Beth',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beth pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beth'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-blake',
    name: 'Pear - Blake',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Blake pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blake'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-blanquet-precoce',
    name: 'Pear - Blanquet Precoce',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Blanquet Precoce pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blanquet Precoce'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-bon-chretien',
    name: 'Pear - Bon Chretien',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Chretien pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Chretien'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-bon-chretien-dhiver',
    name: 'Pear - Bon Chretien dHiver',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Chretien dHiver pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Chretien dHiver'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-bon-chretien-dete',
    name: 'Pear - Bon Chretien dEte',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Chretien dEte pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Chretien dEte'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-bon-rouge',
    name: 'Pear - Bon Rouge',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Rouge pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Rouge'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-boree',
    name: 'Pear - Boree',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Boree pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Boree'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-boseck',
    name: 'Pear - Boseck',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Boseck pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Boseck'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-bouchee',
    name: 'Pear - Bouchee',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bouchee pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bouchee'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-boussock',
    name: 'Pear - Boussock',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Boussock pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Boussock'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-brandy',
    name: 'Pear - Brandy',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Brandy pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Brandy'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-bristol',
    name: 'Pear - Bristol',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bristol pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bristol'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-brown-bosc',
    name: 'Pear - Brown Bosc',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Brown Bosc pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Brown Bosc'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-brown-beurre',
    name: 'Pear - Brown Beurre',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Brown Beurre pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Brown Beurre'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-buerre-bosc',
    name: 'Pear - Buerre Bosc',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Bosc pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Bosc'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-buerre-diel',
    name: 'Pear - Buerre Diel',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Diel pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Diel'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-buerre-durandeau',
    name: 'Pear - Buerre Durandeau',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Durandeau pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Durandeau'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-buerre-giffard',
    name: 'Pear - Buerre Giffard',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Giffard pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Giffard'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-buerre-hardy',
    name: 'Pear - Buerre Hardy',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Hardy pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Hardy'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-buerre-sterckmans',
    name: 'Pear - Buerre Sterckmans',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Sterckmans pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Sterckmans'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-buerre-superfin',
    name: 'Pear - Buerre Superfin',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Superfin pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Superfin'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-buerre-tremlett',
    name: 'Pear - Buerre Tremlett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Tremlett pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Tremlett'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-buerre-vidal',
    name: 'Pear - Buerre Vidal',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Vidal pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Vidal'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-buttira-precoce-morettini',
    name: 'Pear - Buttira Precoce Morettini',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buttira Precoce Morettini pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buttira Precoce Morettini'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-cacanska-lepotica',
    name: 'Pear - Cacanska Lepotica',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Cacanska Lepotica pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cacanska Lepotica'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-calypso',
    name: 'Pear - Calypso',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Calypso pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Calypso'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-canadienne',
    name: 'Pear - Canadienne',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Canadienne pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Canadienne'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-cascade',
    name: 'Pear - Cascade',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Cascade pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cascade'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-catillac',
    name: 'Pear - Catillac',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Catillac pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Catillac'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-celina',
    name: 'Pear - Celina',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Celina pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Celina'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-chang',
    name: 'Pear - Chang',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Chang pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chang'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-chojuro',
    name: 'Pear - Chojuro',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Chojuro pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chojuro'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-christmas',
    name: 'Pear - Christmas',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Christmas pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Christmas'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-clara-frijs',
    name: 'Pear - Clara Frijs',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clara Frijs pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clara Frijs'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-clemen',
    name: 'Pear - Clemen',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clemen pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clemen'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-cockle',
    name: 'Pear - Cockle',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Cockle pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cockle'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-colmar-dete',
    name: 'Pear - Colmar dEte',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Colmar dEte pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Colmar dEte'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-colmar-dhiver',
    name: 'Pear - Colmar dHiver',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Colmar dHiver pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Colmar dHiver'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-colored-de-juillet',
    name: 'Pear - Colored de Juillet',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Colored de Juillet pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Colored de Juillet'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-comtesse-de-paris',
    name: 'Pear - Comtesse de Paris',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Comtesse de Paris pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Comtesse de Paris'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-condo',
    name: 'Pear - Condo',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Condo pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Condo'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-corella',
    name: 'Pear - Corella',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Corella pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Corella'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-coscia',
    name: 'Pear - Coscia',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Coscia pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Coscia'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-curry',
    name: 'Pear - Curry',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Curry pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Curry'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-daisui-li',
    name: 'Pear - Daisui Li',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Daisui Li pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Daisui Li'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-dawn',
    name: 'Pear - Dawn',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dawn pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dawn'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-dee-ann',
    name: 'Pear - Dee-Ann',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dee-Ann pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dee-Ann'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-delbard',
    name: 'Pear - Delbard',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delbard pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delbard'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-delicious',
    name: 'Pear - Delicious',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delicious pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delicious'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-delfran',
    name: 'Pear - Delfran',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delfran pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delfran'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-delshenandoah',
    name: 'Pear - Delshenandoah',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delshenandoah pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delshenandoah'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-devoe',
    name: 'Pear - Devoe',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Devoe pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Devoe'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-docteur-jules-guyot',
    name: 'Pear - Docteur Jules Guyot',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Docteur Jules Guyot pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Docteur Jules Guyot'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-douglas',
    name: 'Pear - Douglas',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Douglas pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Douglas'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-doyenne-dete',
    name: 'Pear - Doyenne dEte',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne dEte pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne dEte'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-doyenne-de-juillet',
    name: 'Pear - Doyenne de Juillet',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne de Juillet pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne de Juillet'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-doyenne-de-port-philip',
    name: 'Pear - Doyenne de Port Philip',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne de Port Philip pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne de Port Philip'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-doyenne-du-comice',
    name: 'Pear - Doyenne du Comice',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne du Comice pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne du Comice'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-drouard',
    name: 'Pear - Drouard',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Drouard pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Drouard'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-dr-van-der-merwe',
    name: 'Pear - Dr Van der Merwe',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dr Van der Merwe pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dr Van der Merwe'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-duc-de-bordeaux',
    name: 'Pear - Duc de Bordeaux',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duc de Bordeaux pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duc de Bordeaux'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-duc-dorleans',
    name: 'Pear - Duc dOrleans',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duc dOrleans pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duc dOrleans'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-duchesse-dangouleme',
    name: 'Pear - Duchesse dAngouleme',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse dAngouleme pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse dAngouleme'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-duchesse-de-berry',
    name: 'Pear - Duchesse de Berry',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse de Berry pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse de Berry'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-duchesse-de-bordeaux',
    name: 'Pear - Duchesse de Bordeaux',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse de Bordeaux pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse de Bordeaux'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-duchesse-de-nemours',
    name: 'Pear - Duchesse de Nemours',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse de Nemours pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse de Nemours'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-duerrenmatt',
    name: 'Pear - Duerrenmatt',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duerrenmatt pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duerrenmatt'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-durondeau',
    name: 'Pear - Durondeau',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Durondeau pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Durondeau'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-early-harvest',
    name: 'Pear - Early Harvest',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Early Harvest pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Early Harvest'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-easter-beurre',
    name: 'Pear - Easter Beurre',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Easter Beurre pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Easter Beurre'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-edelborsdorfer',
    name: 'Pear - Edelborsdorfer',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Edelborsdorfer pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Edelborsdorfer'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-elongata',
    name: 'Pear - Elongata',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Elongata pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elongata'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-elstar',
    name: 'Pear - Elstar',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Elstar pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elstar'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-emerald',
    name: 'Pear - Emerald',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Emerald pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Emerald'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-emile-dheyst',
    name: 'Pear - Emile dHeyst',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Emile dHeyst pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Emile dHeyst'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-eparvier',
    name: 'Pear - Eparvier',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Eparvier pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Eparvier'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-epine-du-mas',
    name: 'Pear - Epine du Mas',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Epine du Mas pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Epine du Mas'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-erabarrow',
    name: 'Pear - Erabarrow',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Erabarrow pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Erabarrow'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-ercolini',
    name: 'Pear - Ercolini',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ercolini pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ercolini'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-ewart',
    name: 'Pear - Ewart',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ewart pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ewart'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-farmingdale',
    name: 'Pear - Farmingdale',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Farmingdale pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Farmingdale'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-fausset',
    name: 'Pear - Fausset',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fausset pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fausset'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-fawcett',
    name: 'Pear - Fawcett',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fawcett pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fawcett'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-fertility',
    name: 'Pear - Fertility',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fertility pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fertility'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-fiesta',
    name: 'Pear - Fiesta',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fiesta pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fiesta'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-flemings-beurre',
    name: 'Pear - Flemings Beurre',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Flemings Beurre pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Flemings Beurre'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-fondante-dautomne',
    name: 'Pear - Fondante dAutomne',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fondante dAutomne pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fondante dAutomne'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-fondante-de-charneux',
    name: 'Pear - Fondante de Charneux',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fondante de Charneux pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fondante de Charneux'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-fondante-de-thirriot',
    name: 'Pear - Fondante de Thirriot',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fondante de Thirriot pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fondante de Thirriot'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-fondante-des-bois',
    name: 'Pear - Fondante des Bois',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fondante des Bois pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fondante des Bois'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-fondante-du-thirriot',
    name: 'Pear - Fondante du Thirriot',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fondante du Thirriot pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fondante du Thirriot'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-forelle',
    name: 'Pear - Forelle',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Forelle pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Forelle'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-frederick',
    name: 'Pear - Frederick',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Frederick pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Frederick'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-freyberg',
    name: 'Pear - Freyberg',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Freyberg pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Freyberg'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-gellerts-butterbirne',
    name: 'Pear - Gellerts Butterbirne',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Gellerts Butterbirne pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gellerts Butterbirne'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-general-leclerc',
    name: 'Pear - General Leclerc',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'General Leclerc pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['General Leclerc'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-general-todleben',
    name: 'Pear - General Todleben',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'General Todleben pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['General Todleben'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-generale-vicomtesse-de-boreau',
    name: 'Pear - Generale Vicomtesse de Boreau',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Generale Vicomtesse de Boreau pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Generale Vicomtesse de Boreau'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-georges-v',
    name: 'Pear - Georges V',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Georges V pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Georges V'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-giffard',
    name: 'Pear - Giffard',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Giffard pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Giffard'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-gilberts-gold',
    name: 'Pear - Gilberts Gold',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Gilberts Gold pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gilberts Gold'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-gill',
    name: 'Pear - Gill',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Gill pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gill'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-glou-morceau',
    name: 'Pear - Glou Morceau',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Glou Morceau pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Glou Morceau'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-gorham',
    name: 'Pear - Gorham',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Gorham pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gorham'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-grand-champion',
    name: 'Pear - Grand Champion',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Grand Champion pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Grand Champion'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-grand',
    name: 'Pear - Grand',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Grand pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Grand'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-greffier',
    name: 'Pear - Greffier',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Greffier pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Greffier'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-grosse-calebasse',
    name: 'Pear - Grosse Calebasse',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Grosse Calebasse pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Grosse Calebasse'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-grosse-marolle',
    name: 'Pear - Grosse Marolle',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Grosse Marolle pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Grosse Marolle'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-grosse-monstrueuse-de-epernay',
    name: 'Pear - Grosse Monstrueuse de Epernay',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Grosse Monstrueuse de Epernay pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Grosse Monstrueuse de Epernay'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-grosse-teton-de-thirache',
    name: 'Pear - Grosse Teton de Thirache',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Grosse Teton de Thirache pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Grosse Teton de Thirache'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-guyot',
    name: 'Pear - Guyot',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Guyot pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Guyot'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-hames-alexander',
    name: 'Pear - Hames Alexander',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hames Alexander pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hames Alexander'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-harrow-delight',
    name: 'Pear - Harrow Delight',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Delight pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Delight'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-harrow-sweet',
    name: 'Pear - Harrow Sweet',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Sweet pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Sweet'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-harvest-queen',
    name: 'Pear - Harvest Queen',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harvest Queen pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harvest Queen'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-hendre-huffcap',
    name: 'Pear - Hendre Huffcap',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hendre Huffcap pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hendre Huffcap'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-henriette-de-bierbais',
    name: 'Pear - Henriette de Bierbais',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Henriette de Bierbais pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Henriette de Bierbais'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-hessle',
    name: 'Pear - Hessle',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hessle pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hessle'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-highland',
    name: 'Pear - Highland',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Highland pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Highland'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-honeysweet',
    name: 'Pear - Honeysweet',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Honeysweet pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Honeysweet'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-hood-river',
    name: 'Pear - Hood River',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hood River pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hood River'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-hortensia',
    name: 'Pear - Hortensia',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hortensia pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hortensia'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-hosui',
    name: 'Pear - Hosui',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hosui pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hosui'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-humbug',
    name: 'Pear - Humbug',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Humbug pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Humbug'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-huntington',
    name: 'Pear - Huntington',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Huntington pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Huntington'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-imperial',
    name: 'Pear - Imperial',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Imperial pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Imperial'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-isolda',
    name: 'Pear - Isolda',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Isolda pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Isolda'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-jackson',
    name: 'Pear - Jackson',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Jackson pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jackson'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-jeanne-darc',
    name: 'Pear - Jeanne dArc',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Jeanne dArc pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jeanne dArc'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-josephine-de-malines',
    name: 'Pear - Josephine de Malines',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Josephine de Malines pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Josephine de Malines'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-jubilee',
    name: 'Pear - Jubilee',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Jubilee pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jubilee'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-jules-darolles',
    name: 'Pear - Jules dArolles',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Jules dArolles pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jules dArolles'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-jules-grivart',
    name: 'Pear - Jules Grivart',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Jules Grivart pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jules Grivart'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-jumilla',
    name: 'Pear - Jumilla',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Jumilla pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Jumilla'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-kalle',
    name: 'Pear - Kalle',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Kalle pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kalle'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-kieffer',
    name: 'Pear - Kieffer',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Kieffer pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kieffer'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-kikusui',
    name: 'Pear - Kikusui',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Kikusui pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kikusui'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-laxtons-superb',
    name: 'Pear - Laxtons Superb',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Laxtons Superb pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Laxtons Superb'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-laxtons-foremost',
    name: 'Pear - Laxtons Foremost',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Laxtons Foremost pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Laxtons Foremost'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-le-lectier',
    name: 'Pear - Le Lectier',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Le Lectier pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Le Lectier'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-lemon',
    name: 'Pear - Lemon',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Lemon pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Lemon'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-limburg',
    name: 'Pear - Limburg',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Limburg pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Limburg'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-bartlett-2',
    name: 'Pear - Bartlett 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bartlett 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bartlett 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-bosc-2',
    name: 'Pear - Bosc 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bosc 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bosc 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-anjou-2',
    name: 'Pear - Anjou 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Anjou 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Anjou 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-comice-2',
    name: 'Pear - Comice 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Comice 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Comice 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-seckel-2',
    name: 'Pear - Seckel 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Seckel 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Seckel 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-concorde-2',
    name: 'Pear - Concorde 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Concorde 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Concorde 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-forelle-2',
    name: 'Pear - Forelle 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Forelle 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Forelle 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-red-bartlett-2',
    name: 'Pear - Red Bartlett 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Red Bartlett 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Bartlett 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-green-anjou-2',
    name: 'Pear - Green Anjou 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Green Anjou 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Green Anjou 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-red-anjou-2',
    name: 'Pear - Red Anjou 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Red Anjou 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Red Anjou 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-danjou-2',
    name: 'Pear - DAnjou 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'DAnjou 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['DAnjou 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-packham-2',
    name: 'Pear - Packham 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Packham 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Packham 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-abate-fetel-2',
    name: 'Pear - Abate Fetel 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Abate Fetel 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Abate Fetel 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-magness-2',
    name: 'Pear - Magness 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Magness 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Magness 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-moonglow-2',
    name: 'Pear - Moonglow 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Moonglow 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Moonglow 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-harrow-sweet-2',
    name: 'Pear - Harrow Sweet 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Sweet 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Sweet 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-harrow-delight-2',
    name: 'Pear - Harrow Delight 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Delight 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Delight 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-harrow-crisp-2',
    name: 'Pear - Harrow Crisp 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Crisp 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Crisp 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-harrow-gold-2',
    name: 'Pear - Harrow Gold 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Gold 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Gold 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-harrow-sun-2',
    name: 'Pear - Harrow Sun 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Harrow Sun 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Harrow Sun 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-potomac-2',
    name: 'Pear - Potomac 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Potomac 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Potomac 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-shenandoah-2',
    name: 'Pear - Shenandoah 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Shenandoah 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Shenandoah 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-ayers-2',
    name: 'Pear - Ayers 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ayers 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ayers 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-warren-2',
    name: 'Pear - Warren 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Warren 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Warren 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-kieffer-2',
    name: 'Pear - Kieffer 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Kieffer 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kieffer 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-orient-2',
    name: 'Pear - Orient 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Orient 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Orient 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-le-conte-2',
    name: 'Pear - Le Conte 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Le Conte 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Le Conte 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-maxine-2',
    name: 'Pear - Maxine 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Maxine 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Maxine 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-starking-delicious-2',
    name: 'Pear - Starking Delicious 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Starking Delicious 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Starking Delicious 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-bosc-2',
    name: 'Pear - Beurre Bosc 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Bosc 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Bosc 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-danjou-2',
    name: 'Pear - Beurre dAnjou 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dAnjou 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dAnjou 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-hardy-2',
    name: 'Pear - Beurre Hardy 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Hardy 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Hardy 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-superfin-2',
    name: 'Pear - Beurre Superfin 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Superfin 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Superfin 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-bristol-cross-2',
    name: 'Pear - Bristol Cross 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bristol Cross 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bristol Cross 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-butirra-precoce-morettini-2',
    name: 'Pear - Butirra Precoce Morettini 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Butirra Precoce Morettini 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Butirra Precoce Morettini 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-clapps-favorite-2',
    name: 'Pear - Clapps Favorite 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clapps Favorite 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clapps Favorite 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-clapps-red-2',
    name: 'Pear - Clapps Red 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clapps Red 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clapps Red 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-conference-2',
    name: 'Pear - Conference 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Conference 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Conference 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-doyenne-du-comice-2',
    name: 'Pear - Doyenne du Comice 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne du Comice 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne du Comice 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-dr-jules-guyot-2',
    name: 'Pear - Dr Jules Guyot 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dr Jules Guyot 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dr Jules Guyot 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-duchess-2',
    name: 'Pear - Duchess 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchess 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchess 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-flemish-beauty-2',
    name: 'Pear - Flemish Beauty 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Flemish Beauty 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Flemish Beauty 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-gorham-2',
    name: 'Pear - Gorham 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Gorham 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Gorham 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-hood-2',
    name: 'Pear - Hood 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hood 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hood 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-hosui-2',
    name: 'Pear - Hosui 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Hosui 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Hosui 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-kikusui-2',
    name: 'Pear - Kikusui 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Kikusui 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Kikusui 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-luscious-2',
    name: 'Pear - Luscious 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Luscious 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Luscious 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-nova-2',
    name: 'Pear - Nova 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Nova 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Nova 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-parker-2',
    name: 'Pear - Parker 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Parker 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Parker 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-paragon-2',
    name: 'Pear - Paragon 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Paragon 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Paragon 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-pineapple-2',
    name: 'Pear - Pineapple 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Pineapple 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Pineapple 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-rousselet-2',
    name: 'Pear - Rousselet 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Rousselet 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Rousselet 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-santa-maria-2',
    name: 'Pear - Santa Maria 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Santa Maria 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Santa Maria 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-shinseiki-2',
    name: 'Pear - Shinseiki 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Shinseiki 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Shinseiki 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-spalding-2',
    name: 'Pear - Spalding 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Spalding 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spalding 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-spartlett-2',
    name: 'Pear - Spartlett 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Spartlett 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Spartlett 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-summercrisp-2',
    name: 'Pear - Summercrisp 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Summercrisp 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Summercrisp 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-surecrop-2',
    name: 'Pear - Surecrop 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Surecrop 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Surecrop 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-tsu-li-2',
    name: 'Pear - Tsu Li 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Tsu Li 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Tsu Li 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-20th-century-2',
    name: 'Pear - 20th Century 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: '20th Century 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['20th Century 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-ya-li-2',
    name: 'Pear - Ya Li 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ya Li 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ya Li 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-yoinashi-2',
    name: 'Pear - Yoinashi 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Yoinashi 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Yoinashi 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-ambrosia-2',
    name: 'Pear - Ambrosia 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ambrosia 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ambrosia 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-angelys-2',
    name: 'Pear - Angelys 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Angelys 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Angelys 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-arromagnac-2',
    name: 'Pear - Arromagnac 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Arromagnac 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Arromagnac 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-autumn-bartlett-2',
    name: 'Pear - Autumn Bartlett 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Autumn Bartlett 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Autumn Bartlett 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-baldwin-2',
    name: 'Pear - Baldwin 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Baldwin 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Baldwin 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-barnett-2',
    name: 'Pear - Barnett 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Barnett 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Barnett 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-giffard-2',
    name: 'Pear - Beurre Giffard 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Giffard 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Giffard 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-gris-2',
    name: 'Pear - Beurre Gris 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Gris 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Gris 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-darenberg-2',
    name: 'Pear - Beurre dArenberg 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dArenberg 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dArenberg 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-de-merode-2',
    name: 'Pear - Beurre de Merode 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre de Merode 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre de Merode 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-depine-2',
    name: 'Pear - Beurre dEpine 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dEpine 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dEpine 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-dhardenpont-2',
    name: 'Pear - Beurre dHardenpont 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre dHardenpont 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre dHardenpont 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-de-capiaumont-2',
    name: 'Pear - Beurre de Capiaumont 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre de Capiaumont 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre de Capiaumont 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-de-rance-2',
    name: 'Pear - Beurre de Rance 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre de Rance 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre de Rance 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-diel-2',
    name: 'Pear - Beurre Diel 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Diel 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Diel 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-dumenil-2',
    name: 'Pear - Beurre Dumenil 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Dumenil 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Dumenil 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-durandeau-2',
    name: 'Pear - Beurre Durandeau 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Durandeau 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Durandeau 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-duroi-2',
    name: 'Pear - Beurre Duroi 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Duroi 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Duroi 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-easter-2',
    name: 'Pear - Beurre Easter 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Easter 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Easter 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-bedford-2',
    name: 'Pear - Beurre Bedford 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Bedford 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Bedford 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-sterckmans-2',
    name: 'Pear - Beurre Sterckmans 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Sterckmans 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Sterckmans 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beurre-treyve-2',
    name: 'Pear - Beurre Treyve 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Treyve 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Treyve 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-beurre-van-mons-2',
    name: 'Pear - Beurre Van Mons 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Van Mons 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Van Mons 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-beurre-vidal-2',
    name: 'Pear - Beurre Vidal 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beurre Vidal 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beurre Vidal 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-beth-2',
    name: 'Pear - Beth 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Beth 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Beth 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-blake-2',
    name: 'Pear - Blake 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Blake 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blake 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-blanquet-precoce-2',
    name: 'Pear - Blanquet Precoce 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Blanquet Precoce 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Blanquet Precoce 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-bon-chretien-2',
    name: 'Pear - Bon Chretien 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Chretien 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Chretien 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-bon-chretien-dhiver-2',
    name: 'Pear - Bon Chretien dHiver 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Chretien dHiver 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Chretien dHiver 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-bon-chretien-dete-2',
    name: 'Pear - Bon Chretien dEte 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Chretien dEte 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Chretien dEte 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-bon-rouge-2',
    name: 'Pear - Bon Rouge 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bon Rouge 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bon Rouge 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-boree-2',
    name: 'Pear - Boree 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Boree 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Boree 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-boseck-2',
    name: 'Pear - Boseck 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Boseck 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Boseck 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-bouchee-2',
    name: 'Pear - Bouchee 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bouchee 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bouchee 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-boussock-2',
    name: 'Pear - Boussock 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Boussock 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Boussock 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-brandy-2',
    name: 'Pear - Brandy 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Brandy 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Brandy 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-bristol-2',
    name: 'Pear - Bristol 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Bristol 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Bristol 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-brown-bosc-2',
    name: 'Pear - Brown Bosc 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Brown Bosc 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Brown Bosc 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-brown-beurre-2',
    name: 'Pear - Brown Beurre 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Brown Beurre 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Brown Beurre 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-buerre-bosc-2',
    name: 'Pear - Buerre Bosc 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Bosc 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Bosc 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-buerre-diel-2',
    name: 'Pear - Buerre Diel 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Diel 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Diel 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-buerre-durandeau-2',
    name: 'Pear - Buerre Durandeau 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Durandeau 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Durandeau 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-buerre-giffard-2',
    name: 'Pear - Buerre Giffard 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Giffard 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Giffard 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-buerre-hardy-2',
    name: 'Pear - Buerre Hardy 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Hardy 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Hardy 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-buerre-sterckmans-2',
    name: 'Pear - Buerre Sterckmans 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Sterckmans 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Sterckmans 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-buerre-superfin-2',
    name: 'Pear - Buerre Superfin 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Superfin 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Superfin 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-buerre-tremlett-2',
    name: 'Pear - Buerre Tremlett 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Tremlett 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Tremlett 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-buerre-vidal-2',
    name: 'Pear - Buerre Vidal 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buerre Vidal 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buerre Vidal 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-buttira-precoce-morettini-2',
    name: 'Pear - Buttira Precoce Morettini 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Buttira Precoce Morettini 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Buttira Precoce Morettini 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-cacanska-lepotica-2',
    name: 'Pear - Cacanska Lepotica 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Cacanska Lepotica 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cacanska Lepotica 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-calypso-2',
    name: 'Pear - Calypso 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Calypso 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Calypso 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-canadienne-2',
    name: 'Pear - Canadienne 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Canadienne 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Canadienne 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-cascade-2',
    name: 'Pear - Cascade 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Cascade 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cascade 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-catillac-2',
    name: 'Pear - Catillac 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Catillac 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Catillac 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-celina-2',
    name: 'Pear - Celina 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Celina 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Celina 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-chang-2',
    name: 'Pear - Chang 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Chang 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chang 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-chojuro-2',
    name: 'Pear - Chojuro 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Chojuro 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Chojuro 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-christmas-2',
    name: 'Pear - Christmas 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Christmas 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Christmas 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-clara-frijs-2',
    name: 'Pear - Clara Frijs 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clara Frijs 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clara Frijs 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-clemen-2',
    name: 'Pear - Clemen 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Clemen 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Clemen 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-cockle-2',
    name: 'Pear - Cockle 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Cockle 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Cockle 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-colmar-dete-2',
    name: 'Pear - Colmar dEte 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Colmar dEte 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Colmar dEte 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-colmar-dhiver-2',
    name: 'Pear - Colmar dHiver 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Colmar dHiver 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Colmar dHiver 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-colored-de-juillet-2',
    name: 'Pear - Colored de Juillet 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Colored de Juillet 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Colored de Juillet 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-comtesse-de-paris-2',
    name: 'Pear - Comtesse de Paris 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Comtesse de Paris 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Comtesse de Paris 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-condo-2',
    name: 'Pear - Condo 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Condo 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Condo 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-corella-2',
    name: 'Pear - Corella 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Corella 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Corella 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-coscia-2',
    name: 'Pear - Coscia 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Coscia 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Coscia 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-curry-2',
    name: 'Pear - Curry 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Curry 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Curry 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-daisui-li-2',
    name: 'Pear - Daisui Li 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Daisui Li 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Daisui Li 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-dawn-2',
    name: 'Pear - Dawn 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dawn 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dawn 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-dee-ann-2',
    name: 'Pear - Dee-Ann 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dee-Ann 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dee-Ann 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-delbard-2',
    name: 'Pear - Delbard 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delbard 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delbard 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-delicious-2',
    name: 'Pear - Delicious 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delicious 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delicious 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-delfran-2',
    name: 'Pear - Delfran 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delfran 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delfran 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-delshenandoah-2',
    name: 'Pear - Delshenandoah 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Delshenandoah 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Delshenandoah 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-devoe-2',
    name: 'Pear - Devoe 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Devoe 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Devoe 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-docteur-jules-guyot-2',
    name: 'Pear - Docteur Jules Guyot 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Docteur Jules Guyot 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Docteur Jules Guyot 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-douglas-2',
    name: 'Pear - Douglas 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Douglas 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Douglas 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-doyenne-dete-2',
    name: 'Pear - Doyenne dEte 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne dEte 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne dEte 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-doyenne-de-juillet-2',
    name: 'Pear - Doyenne de Juillet 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne de Juillet 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne de Juillet 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-doyenne-de-port-philip-2',
    name: 'Pear - Doyenne de Port Philip 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne de Port Philip 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne de Port Philip 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-doyenne-du-comice-2',
    name: 'Pear - Doyenne du Comice 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Doyenne du Comice 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Doyenne du Comice 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-drouard-2',
    name: 'Pear - Drouard 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Drouard 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Drouard 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-dr-van-der-merwe-2',
    name: 'Pear - Dr Van der Merwe 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Dr Van der Merwe 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Dr Van der Merwe 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-duc-de-bordeaux-2',
    name: 'Pear - Duc de Bordeaux 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duc de Bordeaux 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duc de Bordeaux 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-duc-dorleans-2',
    name: 'Pear - Duc dOrleans 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duc dOrleans 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duc dOrleans 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-duchesse-dangouleme-2',
    name: 'Pear - Duchesse dAngouleme 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse dAngouleme 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse dAngouleme 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-duchesse-de-berry-2',
    name: 'Pear - Duchesse de Berry 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse de Berry 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse de Berry 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-duchesse-de-bordeaux-2',
    name: 'Pear - Duchesse de Bordeaux 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse de Bordeaux 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse de Bordeaux 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-duchesse-de-nemours-2',
    name: 'Pear - Duchesse de Nemours 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duchesse de Nemours 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duchesse de Nemours 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-duerrenmatt-2',
    name: 'Pear - Duerrenmatt 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Duerrenmatt 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Duerrenmatt 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-durondeau-2',
    name: 'Pear - Durondeau 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Durondeau 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Durondeau 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-early-harvest-2',
    name: 'Pear - Early Harvest 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Early Harvest 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Early Harvest 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-easter-beurre-2',
    name: 'Pear - Easter Beurre 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Easter Beurre 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Easter Beurre 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-edelborsdorfer-2',
    name: 'Pear - Edelborsdorfer 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Edelborsdorfer 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Edelborsdorfer 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-elongata-2',
    name: 'Pear - Elongata 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Elongata 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elongata 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-elstar-2',
    name: 'Pear - Elstar 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Elstar 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Elstar 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-emerald-2',
    name: 'Pear - Emerald 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Emerald 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Emerald 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-emile-dheyst-2',
    name: 'Pear - Emile dHeyst 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Emile dHeyst 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Emile dHeyst 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-eparvier-2',
    name: 'Pear - Eparvier 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Eparvier 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Eparvier 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-epine-du-mas-2',
    name: 'Pear - Epine du Mas 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Epine du Mas 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Epine du Mas 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-erabarrow-2',
    name: 'Pear - Erabarrow 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Erabarrow 2 pear. Firm flesh, perfect for baking and canning. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Erabarrow 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-ercolini-2',
    name: 'Pear - Ercolini 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ercolini 2 pear. Sweet and juicy, multi-purpose variety. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ercolini 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-ewart-2',
    name: 'Pear - Ewart 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Ewart 2 pear. Buttery texture, excellent for fresh eating. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Ewart 2'],
    uses: ['fresh', 'eating']
  },
  {
    id: 'pear-farmingdale-2',
    name: 'Pear - Farmingdale 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Farmingdale 2 pear. Firm flesh, perfect for baking and canning. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Farmingdale 2'],
    uses: ['baking', 'canning', 'preserves']
  },
  {
    id: 'pear-fausset-2',
    name: 'Pear - Fausset 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fausset 2 pear. Sweet and juicy, multi-purpose variety. Needs pollinator variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fausset 2'],
    uses: ['fresh', 'cooking', 'canning']
  },
  {
    id: 'pear-fawcett-2',
    name: 'Pear - Fawcett 2',
    scientificName: 'Pyrus communis',
    category: 'tree',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'chives'],
    enemies: [],
    description: 'Fawcett 2 pear. Buttery texture, excellent for fresh eating. Partially self-fertile.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Fawcett 2'],
    uses: ['fresh', 'eating']
  }
,
  {
    id: 'walnut-chandler',
    name: 'Walnut - Chandler',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chandler walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Chandler'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-hartley',
    name: 'Pecan - Hartley',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hartley pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Hartley'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-howard',
    name: 'Almond - Howard',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Howard almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Howard'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-vina',
    name: 'Hazelnut - Vina',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vina hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Vina'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-franquette',
    name: 'Chestnut - Franquette',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Franquette chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Franquette'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-pedro',
    name: 'Pistachio - Pedro',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pedro pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Pedro'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-payne',
    name: 'Macadamia - Payne',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Payne macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Payne'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-serr',
    name: 'Walnut - Serr',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Serr walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Serr'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-tulare',
    name: 'Pecan - Tulare',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tulare pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Tulare'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-chico',
    name: 'Almond - Chico',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chico almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Chico'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-stuart',
    name: 'Hazelnut - Stuart',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Stuart hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Stuart'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-desirable',
    name: 'Chestnut - Desirable',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Desirable chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Desirable'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-pawnee',
    name: 'Pistachio - Pawnee',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pawnee pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Pawnee'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-cape-fear',
    name: 'Macadamia - Cape Fear',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cape Fear macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Cape Fear'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-sumner',
    name: 'Walnut - Sumner',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sumner walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Sumner'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-kiowa',
    name: 'Pecan - Kiowa',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kiowa pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kiowa'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-cheyenne',
    name: 'Almond - Cheyenne',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cheyenne almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Cheyenne'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-sioux',
    name: 'Hazelnut - Sioux',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sioux hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Sioux'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-choctaw',
    name: 'Chestnut - Choctaw',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Choctaw chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Choctaw'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-mohawk',
    name: 'Pistachio - Mohawk',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mohawk pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Mohawk'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-nonpareil',
    name: 'Macadamia - Nonpareil',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nonpareil macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Nonpareil'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-carmel',
    name: 'Walnut - Carmel',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Carmel walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Carmel'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-mission',
    name: 'Pecan - Mission',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mission pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Mission'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-monterey',
    name: 'Almond - Monterey',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monterey almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Monterey'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-butte',
    name: 'Hazelnut - Butte',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Butte hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Butte'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-padre',
    name: 'Chestnut - Padre',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Padre chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Padre'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-price',
    name: 'Pistachio - Price',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Price pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Price'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-sonora',
    name: 'Macadamia - Sonora',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sonora macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Sonora'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-fritz',
    name: 'Walnut - Fritz',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fritz walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Fritz'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-wood-colony',
    name: 'Pecan - Wood Colony',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wood Colony pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Wood Colony'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-barcelona',
    name: 'Almond - Barcelona',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Barcelona almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Barcelona'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-ennis',
    name: 'Hazelnut - Ennis',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ennis hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Ennis'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-butler',
    name: 'Chestnut - Butler',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Butler chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Butler'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-daviana',
    name: 'Pistachio - Daviana',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daviana pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Daviana'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-hall-giant',
    name: 'Macadamia - Hall Giant',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hall Giant macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Hall Giant'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-jefferson',
    name: 'Walnut - Jefferson',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jefferson walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Jefferson'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-lewis',
    name: 'Pecan - Lewis',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lewis pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Lewis'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-santiam',
    name: 'Almond - Santiam',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Santiam almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Santiam'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-tonda-di-giffoni',
    name: 'Hazelnut - Tonda di Giffoni',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tonda di Giffoni hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Tonda di Giffoni'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-tonda-romana',
    name: 'Chestnut - Tonda Romana',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tonda Romana chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Tonda Romana'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-colossal',
    name: 'Pistachio - Colossal',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colossal pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Colossal'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-nevada',
    name: 'Macadamia - Nevada',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nevada macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Nevada'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-bouche-de-betizac',
    name: 'Walnut - Bouche de Betizac',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouche de Betizac walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Bouche de Betizac'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-labor-day',
    name: 'Pecan - Labor Day',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Labor Day pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Labor Day'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-marrone',
    name: 'Almond - Marrone',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Marrone almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Marrone'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-precoce-migoule',
    name: 'Hazelnut - Precoce Migoule',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Precoce Migoule hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Precoce Migoule'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-sativa',
    name: 'Chestnut - Sativa',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sativa chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Sativa'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-silver-leaf',
    name: 'Pistachio - Silver Leaf',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Silver Leaf pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Silver Leaf'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-skookum',
    name: 'Macadamia - Skookum',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Skookum macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Skookum'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-sleeping-giant',
    name: 'Walnut - Sleeping Giant',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sleeping Giant walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Sleeping Giant'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-kerman',
    name: 'Pecan - Kerman',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kerman pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kerman'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-golden-hills',
    name: 'Almond - Golden Hills',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Hills almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Golden Hills'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-lost-hills',
    name: 'Hazelnut - Lost Hills',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lost Hills hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Lost Hills'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-randy',
    name: 'Chestnut - Randy',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Randy chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Randy'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-peters',
    name: 'Pistachio - Peters',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peters pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Peters'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-beaumont',
    name: 'Macadamia - Beaumont',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Beaumont macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Beaumont'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-cate',
    name: 'Walnut - Cate',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cate walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Cate'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-daddow',
    name: 'Pecan - Daddow',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daddow pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Daddow'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-dennis',
    name: 'Almond - Dennis',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dennis almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Dennis'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-fuji',
    name: 'Hazelnut - Fuji',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fuji hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Fuji'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-greensleeves',
    name: 'Chestnut - Greensleeves',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greensleeves chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Greensleeves'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-hinde',
    name: 'Pistachio - Hinde',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hinde pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Hinde'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-hiku',
    name: 'Macadamia - Hiku',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hiku macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Hiku'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-keaau',
    name: 'Walnut - Keaau',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keaau walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Keaau'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-kakea',
    name: 'Pecan - Kakea',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kakea pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kakea'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-kau',
    name: 'Almond - Kau',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kau almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Kau'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-keauhou',
    name: 'Hazelnut - Keauhou',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keauhou hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Keauhou'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-makai',
    name: 'Chestnut - Makai',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Makai chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Makai'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-makua',
    name: 'Pistachio - Makua',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Makua pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Makua'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-maroochy',
    name: 'Macadamia - Maroochy',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maroochy macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Maroochy'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-mauka',
    name: 'Walnut - Mauka',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mauka walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Mauka'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-miki',
    name: 'Pecan - Miki',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Miki pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Miki'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-morris',
    name: 'Almond - Morris',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Morris almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Morris'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-nelmak',
    name: 'Hazelnut - Nelmak',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nelmak hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Nelmak'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-purvis',
    name: 'Chestnut - Purvis',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purvis chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Purvis'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-pahala',
    name: 'Pistachio - Pahala',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pahala pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Pahala'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-puurvis',
    name: 'Macadamia - Puurvis',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Puurvis macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Puurvis'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-takaka',
    name: 'Walnut - Takaka',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Takaka walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Takaka'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-waimanalo',
    name: 'Pecan - Waimanalo',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waimanalo pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Waimanalo'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-yamhill',
    name: 'Almond - Yamhill',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yamhill almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Yamhill'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-ashley',
    name: 'Hazelnut - Ashley',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ashley hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Ashley'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-mckinley',
    name: 'Chestnut - McKinley',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'McKinley chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['McKinley'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-thomas',
    name: 'Pistachio - Thomas',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thomas pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Thomas'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-schley',
    name: 'Macadamia - Schley',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Schley macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Schley'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-curtis',
    name: 'Walnut - Curtis',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curtis walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Curtis'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-elliott',
    name: 'Pecan - Elliott',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elliott pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Elliott'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-gloria-grande',
    name: 'Almond - Gloria Grande',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gloria Grande almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Gloria Grande'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-lake',
    name: 'Hazelnut - Lake',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lake hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Lake'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-mcdermid',
    name: 'Chestnut - McDermid',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'McDermid chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['McDermid'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-placentia',
    name: 'Pistachio - Placentia',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Placentia pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Placentia'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-romeo',
    name: 'Macadamia - Romeo',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Romeo macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Romeo'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-sexton',
    name: 'Walnut - Sexton',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sexton walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Sexton'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-tehama',
    name: 'Pecan - Tehama',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tehama pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Tehama'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-vina',
    name: 'Almond - Vina',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vina almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Vina'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-whitmore',
    name: 'Hazelnut - Whitmore',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Whitmore hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Whitmore'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-adams',
    name: 'Chestnut - Adams',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Adams chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Adams'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-alberta',
    name: 'Pistachio - Alberta',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alberta pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Alberta'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-alexander',
    name: 'Macadamia - Alexander',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alexander macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Alexander'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-allegheny',
    name: 'Walnut - Allegheny',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Allegheny walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Allegheny'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-amherst',
    name: 'Pecan - Amherst',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Amherst pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Amherst'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-apollo',
    name: 'Almond - Apollo',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apollo almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Apollo'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-baker',
    name: 'Hazelnut - Baker',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baker hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Baker'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-bedco',
    name: 'Chestnut - Bedco',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bedco chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Bedco'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-bixby',
    name: 'Pistachio - Bixby',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bixby pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Bixby'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-black',
    name: 'Macadamia - Black',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Black'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-bonneville',
    name: 'Walnut - Bonneville',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bonneville walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Bonneville'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-bowl',
    name: 'Pecan - Bowl',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bowl pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Bowl'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-broadview',
    name: 'Almond - Broadview',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Broadview almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Broadview'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-carl',
    name: 'Hazelnut - Carl',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Carl hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Carl'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-cascade',
    name: 'Chestnut - Cascade',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cascade chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Cascade'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-chaberte',
    name: 'Pistachio - Chaberte',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chaberte pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Chaberte'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-champion',
    name: 'Macadamia - Champion',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Champion macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Champion'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-chinese',
    name: 'Walnut - Chinese',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Chinese'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-colby',
    name: 'Pecan - Colby',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colby pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Colby'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-columbia',
    name: 'Almond - Columbia',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Columbia almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Columbia'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-cranz',
    name: 'Hazelnut - Cranz',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cranz hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Cranz'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-creveney',
    name: 'Chestnut - Creveney',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Creveney chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Creveney'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-dahlgren',
    name: 'Pistachio - Dahlgren',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dahlgren pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Dahlgren'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-daniels',
    name: 'Macadamia - Daniels',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daniels macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Daniels'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-davis',
    name: 'Walnut - Davis',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Davis walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Davis'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-dodge',
    name: 'Pecan - Dodge',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dodge pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Dodge'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-douglas',
    name: 'Almond - Douglas',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Douglas almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Douglas'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-dunstan',
    name: 'Hazelnut - Dunstan',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dunstan hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Dunstan'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-eaton',
    name: 'Chestnut - Eaton',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eaton chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Eaton'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-ehrhardt',
    name: 'Pistachio - Ehrhardt',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ehrhardt pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Ehrhardt'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-eliott',
    name: 'Macadamia - Eliott',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eliott macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Eliott'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-emerald',
    name: 'Walnut - Emerald',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Emerald walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Emerald'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-english',
    name: 'Pecan - English',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'English pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['English'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-focht',
    name: 'Almond - Focht',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Focht almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Focht'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-fowler',
    name: 'Hazelnut - Fowler',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fowler hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Fowler'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-gellatly',
    name: 'Chestnut - Gellatly',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gellatly chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Gellatly'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-gem',
    name: 'Pistachio - Gem',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gem pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Gem'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-geneva',
    name: 'Macadamia - Geneva',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Geneva macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Geneva'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-gerardi',
    name: 'Walnut - Gerardi',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gerardi walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Gerardi'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-gillespie',
    name: 'Pecan - Gillespie',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gillespie pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Gillespie'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-grimo',
    name: 'Almond - Grimo',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grimo almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Grimo'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-hansen',
    name: 'Hazelnut - Hansen',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hansen hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Hansen'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-harris',
    name: 'Chestnut - Harris',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Harris chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Harris'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-hastings',
    name: 'Pistachio - Hastings',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hastings pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Hastings'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-hazen',
    name: 'Macadamia - Hazen',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hazen macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Hazen'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-helvetia',
    name: 'Walnut - Helvetia',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Helvetia walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Helvetia'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-hennepin',
    name: 'Pecan - Hennepin',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hennepin pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Hennepin'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-hopkins',
    name: 'Almond - Hopkins',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hopkins almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Hopkins'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-idaho',
    name: 'Hazelnut - Idaho',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Idaho hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Idaho'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-imperial',
    name: 'Chestnut - Imperial',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Imperial chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Imperial'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-iowa',
    name: 'Pistachio - Iowa',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Iowa pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Iowa'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-johnson',
    name: 'Macadamia - Johnson',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Johnson macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Johnson'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-jones',
    name: 'Walnut - Jones',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jones walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Jones'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-jupiter',
    name: 'Pecan - Jupiter',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jupiter pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Jupiter'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-kentucky',
    name: 'Almond - Kentucky',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kentucky almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Kentucky'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-kern',
    name: 'Hazelnut - Kern',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kern hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Kern'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-kwik',
    name: 'Chestnut - Kwik',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kwik chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Kwik'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-lake',
    name: 'Pistachio - Lake',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lake pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Lake'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-lambert',
    name: 'Macadamia - Lambert',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lambert macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Lambert'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-lange',
    name: 'Walnut - Lange',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lange walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Lange'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-lincoln',
    name: 'Pecan - Lincoln',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lincoln pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Lincoln'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-littlepage',
    name: 'Almond - Littlepage',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Littlepage almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Littlepage'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-lockwood',
    name: 'Hazelnut - Lockwood',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lockwood hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Lockwood'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-lowe',
    name: 'Chestnut - Lowe',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lowe chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Lowe'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-mahon',
    name: 'Pistachio - Mahon',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mahon pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Mahon'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-chandler-2',
    name: 'Macadamia - Chandler 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chandler 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Chandler 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-hartley-2',
    name: 'Walnut - Hartley 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hartley 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Hartley 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-howard-2',
    name: 'Pecan - Howard 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Howard 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Howard 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-vina-2',
    name: 'Almond - Vina 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vina 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Vina 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-franquette-2',
    name: 'Hazelnut - Franquette 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Franquette 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Franquette 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-pedro-2',
    name: 'Chestnut - Pedro 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pedro 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Pedro 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-payne-2',
    name: 'Pistachio - Payne 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Payne 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Payne 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-serr-2',
    name: 'Macadamia - Serr 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Serr 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Serr 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-tulare-2',
    name: 'Walnut - Tulare 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tulare 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Tulare 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-chico-2',
    name: 'Pecan - Chico 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chico 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Chico 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-stuart-2',
    name: 'Almond - Stuart 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Stuart 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Stuart 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-desirable-2',
    name: 'Hazelnut - Desirable 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Desirable 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Desirable 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-pawnee-2',
    name: 'Chestnut - Pawnee 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pawnee 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Pawnee 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-cape-fear-2',
    name: 'Pistachio - Cape Fear 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cape Fear 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Cape Fear 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-sumner-2',
    name: 'Macadamia - Sumner 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sumner 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Sumner 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-kiowa-2',
    name: 'Walnut - Kiowa 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kiowa 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kiowa 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-cheyenne-2',
    name: 'Pecan - Cheyenne 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cheyenne 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Cheyenne 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-sioux-2',
    name: 'Almond - Sioux 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sioux 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Sioux 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-choctaw-2',
    name: 'Hazelnut - Choctaw 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Choctaw 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Choctaw 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-mohawk-2',
    name: 'Chestnut - Mohawk 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mohawk 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Mohawk 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-nonpareil-2',
    name: 'Pistachio - Nonpareil 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nonpareil 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Nonpareil 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-carmel-2',
    name: 'Macadamia - Carmel 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Carmel 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Carmel 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-mission-2',
    name: 'Walnut - Mission 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mission 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Mission 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-monterey-2',
    name: 'Pecan - Monterey 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monterey 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Monterey 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-butte-2',
    name: 'Almond - Butte 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Butte 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Butte 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-padre-2',
    name: 'Hazelnut - Padre 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Padre 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Padre 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-price-2',
    name: 'Chestnut - Price 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Price 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Price 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-sonora-2',
    name: 'Pistachio - Sonora 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sonora 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Sonora 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-fritz-2',
    name: 'Macadamia - Fritz 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fritz 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Fritz 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-wood-colony-2',
    name: 'Walnut - Wood Colony 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wood Colony 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Wood Colony 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-barcelona-2',
    name: 'Pecan - Barcelona 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Barcelona 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Barcelona 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-ennis-2',
    name: 'Almond - Ennis 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ennis 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Ennis 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-butler-2',
    name: 'Hazelnut - Butler 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Butler 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Butler 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-daviana-2',
    name: 'Chestnut - Daviana 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daviana 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Daviana 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-hall-giant-2',
    name: 'Pistachio - Hall Giant 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hall Giant 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Hall Giant 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-jefferson-2',
    name: 'Macadamia - Jefferson 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jefferson 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Jefferson 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-lewis-2',
    name: 'Walnut - Lewis 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lewis 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Lewis 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-santiam-2',
    name: 'Pecan - Santiam 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Santiam 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Santiam 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-tonda-di-giffoni-2',
    name: 'Almond - Tonda di Giffoni 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tonda di Giffoni 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Tonda di Giffoni 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-tonda-romana-2',
    name: 'Hazelnut - Tonda Romana 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tonda Romana 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Tonda Romana 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-colossal-2',
    name: 'Chestnut - Colossal 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colossal 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Colossal 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-nevada-2',
    name: 'Pistachio - Nevada 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nevada 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Nevada 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-bouche-de-betizac-2',
    name: 'Macadamia - Bouche de Betizac 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouche de Betizac 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Bouche de Betizac 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-labor-day-2',
    name: 'Walnut - Labor Day 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Labor Day 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Labor Day 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-marrone-2',
    name: 'Pecan - Marrone 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Marrone 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Marrone 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-precoce-migoule-2',
    name: 'Almond - Precoce Migoule 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Precoce Migoule 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Precoce Migoule 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-sativa-2',
    name: 'Hazelnut - Sativa 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sativa 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Sativa 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-silver-leaf-2',
    name: 'Chestnut - Silver Leaf 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Silver Leaf 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Silver Leaf 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-skookum-2',
    name: 'Pistachio - Skookum 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Skookum 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Skookum 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-sleeping-giant-2',
    name: 'Macadamia - Sleeping Giant 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sleeping Giant 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Sleeping Giant 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-kerman-2',
    name: 'Walnut - Kerman 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kerman 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kerman 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-golden-hills-2',
    name: 'Pecan - Golden Hills 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Hills 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Golden Hills 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-lost-hills-2',
    name: 'Almond - Lost Hills 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lost Hills 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Lost Hills 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-randy-2',
    name: 'Hazelnut - Randy 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Randy 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Randy 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-peters-2',
    name: 'Chestnut - Peters 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peters 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Peters 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-beaumont-2',
    name: 'Pistachio - Beaumont 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Beaumont 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Beaumont 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-cate-2',
    name: 'Macadamia - Cate 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cate 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Cate 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-daddow-2',
    name: 'Walnut - Daddow 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daddow 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Daddow 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-dennis-2',
    name: 'Pecan - Dennis 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dennis 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Dennis 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-fuji-2',
    name: 'Almond - Fuji 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fuji 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Fuji 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-greensleeves-2',
    name: 'Hazelnut - Greensleeves 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greensleeves 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Greensleeves 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-hinde-2',
    name: 'Chestnut - Hinde 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hinde 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Hinde 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-hiku-2',
    name: 'Pistachio - Hiku 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hiku 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Hiku 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-keaau-2',
    name: 'Macadamia - Keaau 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keaau 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Keaau 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-kakea-2',
    name: 'Walnut - Kakea 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kakea 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kakea 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-kau-2',
    name: 'Pecan - Kau 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kau 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kau 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-keauhou-2',
    name: 'Almond - Keauhou 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keauhou 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Keauhou 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-makai-2',
    name: 'Hazelnut - Makai 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Makai 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Makai 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-makua-2',
    name: 'Chestnut - Makua 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Makua 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Makua 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-maroochy-2',
    name: 'Pistachio - Maroochy 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maroochy 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Maroochy 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-mauka-2',
    name: 'Macadamia - Mauka 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mauka 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Mauka 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-miki-2',
    name: 'Walnut - Miki 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Miki 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Miki 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-morris-2',
    name: 'Pecan - Morris 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Morris 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Morris 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-nelmak-2',
    name: 'Almond - Nelmak 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nelmak 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Nelmak 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-purvis-2',
    name: 'Hazelnut - Purvis 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purvis 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Purvis 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-pahala-2',
    name: 'Chestnut - Pahala 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pahala 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Pahala 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-puurvis-2',
    name: 'Pistachio - Puurvis 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Puurvis 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Puurvis 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-takaka-2',
    name: 'Macadamia - Takaka 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Takaka 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Takaka 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-waimanalo-2',
    name: 'Walnut - Waimanalo 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waimanalo 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Waimanalo 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-yamhill-2',
    name: 'Pecan - Yamhill 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yamhill 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Yamhill 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-ashley-2',
    name: 'Almond - Ashley 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ashley 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Ashley 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-mckinley-2',
    name: 'Hazelnut - McKinley 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'McKinley 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['McKinley 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-thomas-2',
    name: 'Chestnut - Thomas 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Thomas 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Thomas 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-schley-2',
    name: 'Pistachio - Schley 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Schley 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Schley 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-curtis-2',
    name: 'Macadamia - Curtis 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Curtis 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Curtis 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-elliott-2',
    name: 'Walnut - Elliott 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Elliott 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Elliott 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-gloria-grande-2',
    name: 'Pecan - Gloria Grande 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gloria Grande 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Gloria Grande 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-lake-2',
    name: 'Almond - Lake 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lake 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Lake 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-mcdermid-2',
    name: 'Hazelnut - McDermid 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'McDermid 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['McDermid 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-placentia-2',
    name: 'Chestnut - Placentia 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Placentia 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Placentia 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-romeo-2',
    name: 'Pistachio - Romeo 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Romeo 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Romeo 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-sexton-2',
    name: 'Macadamia - Sexton 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sexton 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Sexton 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-tehama-2',
    name: 'Walnut - Tehama 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tehama 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Tehama 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-vina-2',
    name: 'Pecan - Vina 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vina 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Vina 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-whitmore-2',
    name: 'Almond - Whitmore 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Whitmore 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Whitmore 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-adams-2',
    name: 'Hazelnut - Adams 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Adams 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Adams 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-alberta-2',
    name: 'Chestnut - Alberta 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alberta 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Alberta 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-alexander-2',
    name: 'Pistachio - Alexander 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alexander 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Alexander 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-allegheny-2',
    name: 'Macadamia - Allegheny 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Allegheny 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Allegheny 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-amherst-2',
    name: 'Walnut - Amherst 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Amherst 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Amherst 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-apollo-2',
    name: 'Pecan - Apollo 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apollo 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Apollo 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-baker-2',
    name: 'Almond - Baker 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Baker 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Baker 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-bedco-2',
    name: 'Hazelnut - Bedco 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bedco 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Bedco 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-bixby-2',
    name: 'Chestnut - Bixby 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bixby 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Bixby 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-black-2',
    name: 'Pistachio - Black 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Black 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-bonneville-2',
    name: 'Macadamia - Bonneville 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bonneville 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Bonneville 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-bowl-2',
    name: 'Walnut - Bowl 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bowl 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Bowl 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-broadview-2',
    name: 'Pecan - Broadview 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Broadview 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Broadview 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-carl-2',
    name: 'Almond - Carl 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Carl 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Carl 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-cascade-2',
    name: 'Hazelnut - Cascade 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cascade 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Cascade 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-chaberte-2',
    name: 'Chestnut - Chaberte 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chaberte 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Chaberte 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-champion-2',
    name: 'Pistachio - Champion 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Champion 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Champion 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-chinese-2',
    name: 'Macadamia - Chinese 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Chinese 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-colby-2',
    name: 'Walnut - Colby 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colby 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Colby 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-columbia-2',
    name: 'Pecan - Columbia 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Columbia 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Columbia 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-cranz-2',
    name: 'Almond - Cranz 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cranz 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Cranz 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-creveney-2',
    name: 'Hazelnut - Creveney 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Creveney 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Creveney 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-dahlgren-2',
    name: 'Chestnut - Dahlgren 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dahlgren 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Dahlgren 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-daniels-2',
    name: 'Pistachio - Daniels 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daniels 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Daniels 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-davis-2',
    name: 'Macadamia - Davis 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Davis 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Davis 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-dodge-2',
    name: 'Walnut - Dodge 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dodge 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Dodge 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-douglas-2',
    name: 'Pecan - Douglas 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Douglas 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Douglas 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-dunstan-2',
    name: 'Almond - Dunstan 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dunstan 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Dunstan 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-eaton-2',
    name: 'Hazelnut - Eaton 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eaton 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Eaton 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-ehrhardt-2',
    name: 'Chestnut - Ehrhardt 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ehrhardt 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Ehrhardt 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-eliott-2',
    name: 'Pistachio - Eliott 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eliott 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Eliott 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-emerald-2',
    name: 'Macadamia - Emerald 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Emerald 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Emerald 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-english-2',
    name: 'Walnut - English 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'English 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['English 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-focht-2',
    name: 'Pecan - Focht 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Focht 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Focht 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-fowler-2',
    name: 'Almond - Fowler 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fowler 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Fowler 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-gellatly-2',
    name: 'Hazelnut - Gellatly 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gellatly 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Gellatly 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-gem-2',
    name: 'Chestnut - Gem 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gem 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Gem 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-geneva-2',
    name: 'Pistachio - Geneva 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Geneva 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Geneva 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-gerardi-2',
    name: 'Macadamia - Gerardi 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gerardi 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Gerardi 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-gillespie-2',
    name: 'Walnut - Gillespie 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gillespie 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Gillespie 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-grimo-2',
    name: 'Pecan - Grimo 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grimo 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Grimo 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-hansen-2',
    name: 'Almond - Hansen 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hansen 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Hansen 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-harris-2',
    name: 'Hazelnut - Harris 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Harris 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Harris 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-hastings-2',
    name: 'Chestnut - Hastings 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hastings 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Hastings 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-hazen-2',
    name: 'Pistachio - Hazen 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hazen 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Hazen 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-helvetia-2',
    name: 'Macadamia - Helvetia 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Helvetia 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Helvetia 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-hennepin-2',
    name: 'Walnut - Hennepin 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hennepin 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Hennepin 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-hopkins-2',
    name: 'Pecan - Hopkins 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hopkins 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Hopkins 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-idaho-2',
    name: 'Almond - Idaho 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Idaho 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Idaho 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-imperial-2',
    name: 'Hazelnut - Imperial 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Imperial 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Imperial 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-iowa-2',
    name: 'Chestnut - Iowa 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Iowa 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Iowa 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-johnson-2',
    name: 'Pistachio - Johnson 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Johnson 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Johnson 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-jones-2',
    name: 'Macadamia - Jones 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jones 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Jones 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-jupiter-2',
    name: 'Walnut - Jupiter 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jupiter 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Jupiter 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-kentucky-2',
    name: 'Pecan - Kentucky 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kentucky 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kentucky 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-kern-2',
    name: 'Almond - Kern 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kern 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Kern 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-kwik-2',
    name: 'Hazelnut - Kwik 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kwik 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Kwik 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-lake-2',
    name: 'Chestnut - Lake 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lake 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Lake 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-lambert-2',
    name: 'Pistachio - Lambert 2',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lambert 2 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Lambert 2'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-lange-2',
    name: 'Macadamia - Lange 2',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lange 2 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Lange 2'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-lincoln-2',
    name: 'Walnut - Lincoln 2',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lincoln 2 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Lincoln 2'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-littlepage-2',
    name: 'Pecan - Littlepage 2',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Littlepage 2 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Littlepage 2'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-lockwood-2',
    name: 'Almond - Lockwood 2',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lockwood 2 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Lockwood 2'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-lowe-2',
    name: 'Hazelnut - Lowe 2',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lowe 2 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Lowe 2'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-mahon-2',
    name: 'Chestnut - Mahon 2',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mahon 2 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Mahon 2'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-chandler-3',
    name: 'Pistachio - Chandler 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chandler 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Chandler 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-hartley-3',
    name: 'Macadamia - Hartley 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hartley 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Hartley 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-howard-3',
    name: 'Walnut - Howard 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Howard 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Howard 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-vina-3',
    name: 'Pecan - Vina 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vina 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Vina 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-franquette-3',
    name: 'Almond - Franquette 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Franquette 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Franquette 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-pedro-3',
    name: 'Hazelnut - Pedro 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pedro 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Pedro 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-payne-3',
    name: 'Chestnut - Payne 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Payne 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Payne 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-serr-3',
    name: 'Pistachio - Serr 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Serr 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Serr 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-tulare-3',
    name: 'Macadamia - Tulare 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tulare 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Tulare 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-chico-3',
    name: 'Walnut - Chico 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chico 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Chico 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-stuart-3',
    name: 'Pecan - Stuart 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Stuart 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Stuart 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-desirable-3',
    name: 'Almond - Desirable 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Desirable 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Desirable 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-pawnee-3',
    name: 'Hazelnut - Pawnee 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pawnee 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Pawnee 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-cape-fear-3',
    name: 'Chestnut - Cape Fear 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cape Fear 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Cape Fear 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-sumner-3',
    name: 'Pistachio - Sumner 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sumner 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Sumner 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-kiowa-3',
    name: 'Macadamia - Kiowa 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kiowa 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Kiowa 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-cheyenne-3',
    name: 'Walnut - Cheyenne 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cheyenne 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Cheyenne 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-sioux-3',
    name: 'Pecan - Sioux 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sioux 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Sioux 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-choctaw-3',
    name: 'Almond - Choctaw 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Choctaw 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Choctaw 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-mohawk-3',
    name: 'Hazelnut - Mohawk 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mohawk 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Mohawk 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-nonpareil-3',
    name: 'Chestnut - Nonpareil 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nonpareil 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Nonpareil 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-carmel-3',
    name: 'Pistachio - Carmel 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Carmel 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Carmel 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-mission-3',
    name: 'Macadamia - Mission 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mission 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Mission 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-monterey-3',
    name: 'Walnut - Monterey 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monterey 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Monterey 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-butte-3',
    name: 'Pecan - Butte 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Butte 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Butte 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-padre-3',
    name: 'Almond - Padre 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Padre 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Padre 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-price-3',
    name: 'Hazelnut - Price 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Price 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Price 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-sonora-3',
    name: 'Chestnut - Sonora 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sonora 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Sonora 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-fritz-3',
    name: 'Pistachio - Fritz 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fritz 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Fritz 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-wood-colony-3',
    name: 'Macadamia - Wood Colony 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wood Colony 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Wood Colony 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-barcelona-3',
    name: 'Walnut - Barcelona 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Barcelona 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Barcelona 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-ennis-3',
    name: 'Pecan - Ennis 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ennis 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Ennis 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-butler-3',
    name: 'Almond - Butler 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Butler 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Butler 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-daviana-3',
    name: 'Hazelnut - Daviana 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daviana 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Daviana 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-hall-giant-3',
    name: 'Chestnut - Hall Giant 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hall Giant 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Hall Giant 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-jefferson-3',
    name: 'Pistachio - Jefferson 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jefferson 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Jefferson 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-lewis-3',
    name: 'Macadamia - Lewis 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lewis 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Lewis 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-santiam-3',
    name: 'Walnut - Santiam 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Santiam 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Santiam 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-tonda-di-giffoni-3',
    name: 'Pecan - Tonda di Giffoni 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tonda di Giffoni 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Tonda di Giffoni 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-tonda-romana-3',
    name: 'Almond - Tonda Romana 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tonda Romana 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Tonda Romana 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-colossal-3',
    name: 'Hazelnut - Colossal 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colossal 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Colossal 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-nevada-3',
    name: 'Chestnut - Nevada 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nevada 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Nevada 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-bouche-de-betizac-3',
    name: 'Pistachio - Bouche de Betizac 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bouche de Betizac 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Bouche de Betizac 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-labor-day-3',
    name: 'Macadamia - Labor Day 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Labor Day 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Labor Day 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-marrone-3',
    name: 'Walnut - Marrone 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Marrone 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Marrone 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-precoce-migoule-3',
    name: 'Pecan - Precoce Migoule 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Precoce Migoule 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Precoce Migoule 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-sativa-3',
    name: 'Almond - Sativa 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sativa 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Sativa 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-silver-leaf-3',
    name: 'Hazelnut - Silver Leaf 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Silver Leaf 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Silver Leaf 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-skookum-3',
    name: 'Chestnut - Skookum 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Skookum 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Skookum 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-sleeping-giant-3',
    name: 'Pistachio - Sleeping Giant 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sleeping Giant 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Sleeping Giant 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-kerman-3',
    name: 'Macadamia - Kerman 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kerman 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Kerman 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-golden-hills-3',
    name: 'Walnut - Golden Hills 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Hills 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Golden Hills 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-lost-hills-3',
    name: 'Pecan - Lost Hills 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lost Hills 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Lost Hills 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-randy-3',
    name: 'Almond - Randy 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Randy 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Randy 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-peters-3',
    name: 'Hazelnut - Peters 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peters 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Peters 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-beaumont-3',
    name: 'Chestnut - Beaumont 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Beaumont 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Beaumont 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-cate-3',
    name: 'Pistachio - Cate 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cate 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Cate 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-daddow-3',
    name: 'Macadamia - Daddow 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daddow 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Daddow 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-dennis-3',
    name: 'Walnut - Dennis 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dennis 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Dennis 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-fuji-3',
    name: 'Pecan - Fuji 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fuji 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Fuji 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-greensleeves-3',
    name: 'Almond - Greensleeves 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Greensleeves 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Greensleeves 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-hinde-3',
    name: 'Hazelnut - Hinde 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hinde 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Hinde 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-hiku-3',
    name: 'Chestnut - Hiku 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hiku 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Hiku 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-keaau-3',
    name: 'Pistachio - Keaau 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keaau 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Keaau 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-kakea-3',
    name: 'Macadamia - Kakea 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kakea 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Kakea 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-kau-3',
    name: 'Walnut - Kau 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kau 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Kau 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-keauhou-3',
    name: 'Pecan - Keauhou 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Keauhou 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Keauhou 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-makai-3',
    name: 'Almond - Makai 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Makai 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Makai 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-makua-3',
    name: 'Hazelnut - Makua 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Makua 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Makua 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-maroochy-3',
    name: 'Chestnut - Maroochy 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maroochy 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Maroochy 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-mauka-3',
    name: 'Pistachio - Mauka 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mauka 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Mauka 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-miki-3',
    name: 'Macadamia - Miki 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Miki 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Miki 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-morris-3',
    name: 'Walnut - Morris 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Morris 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Morris 3'],
    uses: ['baking', 'salads', 'snacking']
  },
  {
    id: 'pecan-nelmak-3',
    name: 'Pecan - Nelmak 3',
    scientificName: 'Carya illinoinensis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nelmak 3 pecan. Sweet and rich, perfect for pies. Large tree, long-lived.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Nelmak 3'],
    uses: ['pies', 'baking', 'candy']
  },
  {
    id: 'almond-purvis-3',
    name: 'Almond - Purvis 3',
    scientificName: 'Prunus dulcis',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purvis 3 almond. Mild and versatile, great for snacking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Rosaceae',
    varieties: ['Purvis 3'],
    uses: ['snacking', 'milk', 'baking']
  },
  {
    id: 'hazelnut-pahala-3',
    name: 'Hazelnut - Pahala 3',
    scientificName: 'Corylus avellana',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pahala 3 hazelnut. Rich flavor, perfect for chocolate and coffee. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Betulaceae',
    varieties: ['Pahala 3'],
    uses: ['chocolate', 'coffee', 'baking']
  },
  {
    id: 'chestnut-puurvis-3',
    name: 'Chestnut - Puurvis 3',
    scientificName: 'Castanea sativa',
    category: 'tree',
    spacing: 240,
    rowSpacing: 300,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Puurvis 3 chestnut. Sweet and starchy, roast or boil. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-60 feet',
    spread: '40-50 feet',
    family: 'Fagaceae',
    varieties: ['Puurvis 3'],
    uses: ['roasting', 'stuffing', 'flour']
  },
  {
    id: 'pistachio-takaka-3',
    name: 'Pistachio - Takaka 3',
    scientificName: 'Pistacia vera',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1460,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Takaka 3 pistachio. Unique green color, addictive flavor. Large tree, long-lived.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Anacardiaceae',
    varieties: ['Takaka 3'],
    uses: ['snacking', 'ice cream', 'baking']
  },
  {
    id: 'macadamia-waimanalo-3',
    name: 'Macadamia - Waimanalo 3',
    scientificName: 'Macadamia integrifolia',
    category: 'tree',
    spacing: 180,
    rowSpacing: 240,
    daysToGermination: 0,
    daysToHarvest: 1825,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Waimanalo 3 macadamia. Creamy and rich, gourmet nut. Large tree, long-lived.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '30-40 feet',
    spread: '25-30 feet',
    family: 'Proteaceae',
    varieties: ['Waimanalo 3'],
    uses: ['snacking', 'cooking', 'oil']
  },
  {
    id: 'walnut-yamhill-3',
    name: 'Walnut - Yamhill 3',
    scientificName: 'Juglans regia',
    category: 'tree',
    spacing: 300,
    rowSpacing: 360,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yamhill 3 walnut. Rich, buttery flavor, excellent for baking. Large tree, long-lived.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: '40-50 feet',
    spread: '30-40 feet',
    family: 'Juglandaceae',
    varieties: ['Yamhill 3'],
    uses: ['baking', 'salads', 'snacking']
  }
]
